// krs-sync-stamp: 2026-04-29T13:24
(function () {
  if (typeof window !== 'undefined' && window.__krsBundleBuilderBootstrapped) {
    return;
  }
  if (typeof window !== 'undefined') {
    window.__krsBundleBuilderBootstrapped = true;
  }
 
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function formatMoneyWithoutTrailingZeros(cents) {
    return formatMoney(cents).replace(/([.,]00)(?!\d)/, '');
  }

  function formatMoneyParts(cents) {
    var formatted = formatMoney(cents);
    if (formatted.length < 4) return { dollars: formatted, cents: '' };
    var centsPart = formatted.slice(-3);
    var dollarsPart = formatted.slice(0, -3);
    return { dollars: dollarsPart, cents: centsPart };
  }

  function parseBadgeSavingsCents(text) {
    if (!text) return 0;
    var match = String(text).match(/save\s*[^\d]*(\d+(?:\.\d{1,2})?)/i);
    if (!match) return 0;
    var amount = parseFloat(match[1] || 0);
    return Math.round(amount * 100);
  }

  var PERF_DEBUG_ENABLED = !!(window && window.KRS_BUNDLE_PERF_DEBUG);
  var PERF_SUPPORTED = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.measure === 'function';
  var NO_PICKER_SWAP_ENABLED = !!(window && window.KRS_BUNDLE_NO_PICKER_SWAP);

  function createPerfTools(uid) {
    var enabled = PERF_DEBUG_ENABLED && PERF_SUPPORTED && !!uid;
    var prefix = 'krsBundle:' + uid + ':';
    var summary = {};
    return {
      enabled: enabled,
      mark: function (name) {
        if (!enabled) return;
        performance.mark(prefix + name);
      },
      measure: function (name, start, end) {
        if (!enabled) return;
        try {
          performance.measure(prefix + name, prefix + start, prefix + end);
          var entries = performance.getEntriesByName(prefix + name);
          if (entries && entries.length) {
            summary[name] = Math.round(entries[entries.length - 1].duration * 10) / 10;
          }
          performance.clearMeasures(prefix + name);
        } catch (e) {
          /* noop */
        }
      },
      flush: function () {
        if (!enabled) return;
        try {
          console.info('[krs-bundle-builder][perf][' + uid + ']', summary);
        } catch (e) {
          /* noop */
        }
        Object.keys(summary).forEach(function (key) { delete summary[key]; });
      }
    };
  }

  function initBundleBuilder(root) {
    if (!root || root.getAttribute('data-krs-bundle-initialized') === 'true') return;

    var uid = (root.id || '').replace(/^KrsBundle-/, '');
    if (!uid) return;
    var perf = createPerfTools(uid);
    perf.mark('init-start');

    var strings = {};
    try {
      strings = JSON.parse(root.getAttribute('data-strings') || '{}');
    } catch (e) {
      strings = {};
    }
    function tStr(key, fallback, vars) {
      var template = (strings && strings[key]) || fallback || '';
      if (vars) {
        Object.keys(vars).forEach(function (k) {
          template = template.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), String(vars[k]));
        });
      }
      return template;
    }

    var dataNode = document.getElementById('KrsBundleData-' + uid);
    if (!dataNode) {
      root.setAttribute('data-krs-bundle-debug', 'missing-json-node');
      return;
    }

    var data = {};
    perf.mark('json-parse-start');
    try { 
      data = JSON.parse(dataNode.textContent || '{}');
      perf.mark('json-parse-end');
      perf.measure('json-parse', 'json-parse-start', 'json-parse-end');
    } catch (e) {
      perf.mark('json-parse-end');
      perf.measure('json-parse', 'json-parse-start', 'json-parse-end');
      root.setAttribute('data-krs-bundle-debug', 'json-parse-failed');
      var parseErrorNode = document.createElement('p');
      parseErrorNode.className = 'krs-bundle-builder__empty';
      parseErrorNode.textContent = 'Bundle data failed to load. Check product metafield JSON output.';
      root.appendChild(parseErrorNode);
      return;
    }

    var sizeContainer = document.getElementById('KrsBundleSizes-' + uid);
    var sizeDisclaimerContainer = document.getElementById('KrsBundleSizeDisclaimer-' + uid);
    var sizeDisclaimerTextEl = sizeDisclaimerContainer
      ? sizeDisclaimerContainer.querySelector('[data-role="size-disclaimer-text"]')
      : null;
    var step2Container = document.getElementById('KrsBundleStep2-' + uid);
    var step2LearnMoreBtn = document.getElementById('KrsBundleStep2LearnMore-' + uid);
    var upliftModal = document.getElementById('KrsBundleUpliftModal-' + uid);
    var stepHelmetContainer = document.getElementById('KrsBundleStepHelmet-' + uid);
    var helmetGroupsContainer = document.getElementById('KrsBundleHelmetGroups-' + uid);
    var groupsContainer = document.getElementById('KrsBundleGroups-' + uid);
    var step2Gate = document.getElementById('KrsBundleStep2Gate-' + uid);
    var summaryMain = document.getElementById('KrsBundleSummaryMain-' + uid);
    var summaryItems = document.getElementById('KrsBundleSummaryItems-' + uid);
    var summaryTotal = document.getElementById('KrsBundleSummaryTotal-' + uid);
    var summarySave = document.getElementById('KrsBundleSummarySave-' + uid);
    var addBtn = document.getElementById('KrsBundleAdd-' + uid);
    var summaryEl = root.querySelector('.krs-bundle-builder__summary');

    if (!sizeContainer || !groupsContainer || !summaryMain || !summaryItems || !summaryTotal || !summarySave || !addBtn) {
      root.setAttribute('data-krs-bundle-debug', 'missing-required-nodes');
      return;
    }
    root.setAttribute('data-krs-bundle-debug', 'script-running');
    root.setAttribute('data-krs-bundle-initialized', 'true');

    var state = {
      selectedSize: null,
      selectedVariantId: null,
      selectedVariantPriceCents: 0,
      selectedVariantCompareAtCents: 0,
      selectedGroupId: null, 
      selectedAddons: {},
      pendingAddonSelections: {},
      addonsHydrated: false,
      suppressUrlSync: false,
      groupsRendered: false,
      selectedTwoStepMode: null,
      selectedHelmets: {}
    };
    var twoStepConfig = data && data.twoStepConfig ? data.twoStepConfig : null;
    var twoStepUpliftData = data && data.twoStepUplift ? data.twoStepUplift : null;
    var twoStepAdventureData = data && data.twoStepAdventure ? data.twoStepAdventure : null;
    var twoStepHelmetData = data && data.twoStepHelmet ? data.twoStepHelmet : null;
    var isTwoStepMode = !!(twoStepConfig && twoStepConfig.enabled);
    var groupsData = [];
    var sizeOptionCards = [];
    var setSelectedGroupFn = null;
    var COMBINED_GROUP_IMAGE_BY_KEY = {
      'uplift-backpack': 'https://cdn.shopify.com/s/files/1/0768/0386/6860/files/1_1_90_uplift_balance_bike_backpack_combo_grey_bg_Custom.jpg?v=1773788109'
    }; 
    var UPLIFT_ADDON_SKU = 'KRS-ACC-UBP-1';

    var step3Container = document.getElementById('KrsBundleStep3-' + uid);
    var step3Gate = document.getElementById('KrsBundleStep3Gate-' + uid);
    var addonsContainer = document.getElementById('Slider-KrsBundleAddons-' + uid);
    var addonsSliderComponent = document.getElementById('KrsBundleAddonsSlider-' + uid);
    var addonsButtonsContainer = document.getElementById('KrsBundleAddonsButtons-' + uid);
    var addonsDotsContainer = document.getElementById('KrsBundleAddonsDots-' + uid);
    var addonsCounterTotal = addonsButtonsContainer ? addonsButtonsContainer.querySelector('.slider-counter--total') : null;
    var addonsCounterCurrent = addonsButtonsContainer ? addonsButtonsContainer.querySelector('.slider-counter--current') : null;
    var summaryAddons = document.getElementById('KrsBundleSummaryAddons-' + uid);
    var stickySummaryBar = null;
    var stickySummaryTitle = null;
    var stickySummarySave = null;
    var stickySummaryTotal = null;
    var stickySummaryItems = null;
    var stickySummaryImageWrap = null;
    var stickySummaryImage = null;
    var stickySummaryBtn = null;
    var stickySummaryObserver = null;
    var stickySummaryVisible = false;
    var stickyPaddingTarget = null;
    var stickyOriginalPaddingBottom = '';
    var upliftModalReturnFocusEl = null;
    var upliftModalOriginalParent = null;
    var upliftModalOriginalNextSibling = null;
    var helmetModalReturnFocusEl = null;
    var helmetModalOriginalParents = {};
    var helmetModalOriginalNextSiblings = {};

    function getStickyPaddingTarget() {
      if (stickyPaddingTarget) return stickyPaddingTarget;
      stickyPaddingTarget =
        document.querySelector('main') ||
        document.getElementById('MainContent') ||
        document.querySelector('.main-content') ||
        document.querySelector('.page-content') ||
        document.body;
      return stickyPaddingTarget;
    }

    function setStickyPadding(active) {
      var target = getStickyPaddingTarget();
      if (!target || !stickySummaryBar) return;
      if (active) {
        if (stickyOriginalPaddingBottom === '') {
          stickyOriginalPaddingBottom = window.getComputedStyle(target).paddingBottom || '';
        }
        var stickyHeight = Math.max(stickySummaryBar.offsetHeight || 0, 70);
        target.style.paddingBottom = String(stickyHeight) + 'px';
      } else if (stickyOriginalPaddingBottom !== '') {
        target.style.paddingBottom = stickyOriginalPaddingBottom;
      }
    }

    function showStickySummaryBar() {
      if (!stickySummaryBar || stickySummaryVisible) return;
      stickySummaryVisible = true;
      stickySummaryBar.classList.add('is-visible');
      stickySummaryBar.setAttribute('aria-hidden', 'false');
      setStickyPadding(true);
    }

    function hideStickySummaryBar() {
      if (!stickySummaryBar || !stickySummaryVisible) return;
      stickySummaryVisible = false;
      stickySummaryBar.classList.remove('is-visible');
      stickySummaryBar.setAttribute('aria-hidden', 'true');
      setStickyPadding(false);
    }

    function syncStickySummary() {
      if (!stickySummaryBar || !stickySummaryTitle || !stickySummarySave || !stickySummaryTotal || !stickySummaryBtn) {
        return;
      }
      stickySummaryTitle.textContent = summaryMain ? String(summaryMain.textContent || '') : '';
      stickySummarySave.textContent = summarySave ? String(summarySave.textContent || '') : '';
      stickySummarySave.style.display = stickySummarySave.textContent ? '' : 'none';
      if (summaryTotal) {
        stickySummaryTotal.innerHTML = summaryTotal.innerHTML;
      } else {
        stickySummaryTotal.textContent = '';
      }
      if (stickySummaryItems) {
        var summaryContent = summaryEl ? summaryEl.querySelector('.krs-bundle-builder__summary-content') : null;
        var itemNames = summaryContent
          ? Array.prototype.map.call(summaryContent.querySelectorAll('.krs-bundle-builder__summary-item-name'), function (node) {
              return String(node.textContent || '').trim();
            }).filter(Boolean)
          : [];
        stickySummaryItems.innerHTML = itemNames.map(function (name) {
          return '<div class="krs-bundle-builder-sticky__item-name">' + escapeHtml(name) + '</div>';
        }).join('');
        stickySummaryItems.style.display = itemNames.length ? '' : 'none';
      }
      if (stickySummaryImageWrap && stickySummaryImage) {
        var baseImage = getBaseProductImageForSelectedSize() || (data && data.baseProductImage) || '';
        if (baseImage) {
          var sep = baseImage.indexOf('?') >= 0 ? '&' : '?';
          stickySummaryImage.src = baseImage + sep + 'width=120';
          stickySummaryImage.alt = (data && data.baseProductTitle) || 'Bundle image';
          stickySummaryImageWrap.style.display = '';
        } else {
          stickySummaryImageWrap.style.display = 'none';
        }
      }
      stickySummaryBtn.textContent = addBtn.textContent || tStr('addToCart', 'Add to Cart');
      stickySummaryBtn.disabled = !!addBtn.disabled;
      if (addBtn.disabled) {
        stickySummaryBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickySummaryBtn.removeAttribute('aria-disabled');
      }
    }

    function isMobileViewport() {
      return window.matchMedia ? window.matchMedia('(max-width: 749px)').matches : window.innerWidth <= 749;
    }

    function isElementVisibleInViewport(el) {
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < viewportHeight && rect.left < viewportWidth;
    }

    function shouldShowStickySummary(rect) {
      if (!summaryEl || !state.selectedVariantId) return false;
      var stickyAtcVisible = !!document.querySelector('.sticky-atc-bar.sticky-atc-bar--visible');
      if (stickyAtcVisible) return false;
      if (isMobileViewport()) {
        return !isElementVisibleInViewport(addBtn);
      }
      if (!rect) {
        rect = summaryEl.getBoundingClientRect();
      }
      return rect.bottom < 0;
    }

    function handleStickySummaryVisibility(rect) {
      if (shouldShowStickySummary(rect)) {
        showStickySummaryBar();
      } else {
        hideStickySummaryBar();
      }
    }

    function createStickySummaryBar() {
      var existingSticky = document.getElementById('KrsBundleSticky-' + uid);
      if (existingSticky) {
        existingSticky.remove();
      }
      stickySummaryBar = document.createElement('div');
      stickySummaryBar.id = 'KrsBundleSticky-' + uid;
      stickySummaryBar.className = 'krs-bundle-builder-sticky';
      stickySummaryBar.setAttribute('aria-hidden', 'true');
      stickySummaryBar.innerHTML =
        '<div class="krs-bundle-builder-sticky__inner">' +
          '<div class="krs-bundle-builder-sticky__media" style="display:none">' +
            '<img alt="" loading="lazy" width="50" height="50">' +
          '</div>' +
          '<div class="krs-bundle-builder-sticky__content">' +
            '<p class="krs-bundle-builder-sticky__title"></p>' +
            '<div class="krs-bundle-builder-sticky__items"></div>' +
          '</div>' +
          '<div class="krs-bundle-builder-sticky__actions">' +
            '<div class="krs-bundle-builder-sticky__pricing">' +
              '<strong class="krs-bundle-builder-sticky__total price-item price-item--regular"></strong>' +
              '<p class="krs-bundle-builder-sticky__save krs-bundle-builder__summary-save"></p>' +
            '</div>' +
            '<button type="button" class="krs-bundle-builder-sticky__cta button button--primary">' + escapeHtml(tStr('addToCart', 'Add to Cart')) + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(stickySummaryBar);
      stickySummaryImageWrap = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__media');
      stickySummaryImage = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__media img');
      stickySummaryTitle = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__title');
      stickySummarySave = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__save');
      stickySummaryTotal = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__total');
      stickySummaryItems = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__items');
      stickySummaryBtn = stickySummaryBar.querySelector('.krs-bundle-builder-sticky__cta');
      if (stickySummaryBtn) {
        stickySummaryBtn.addEventListener('click', function () {
          if (!addBtn.disabled) addBtn.click();
        });
      }
      syncStickySummary();
    }

    function setupStickySummaryObserver() {
      if (!summaryEl || !stickySummaryBar) return;
      window.addEventListener('resize', function () {
        handleStickySummaryVisibility();
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        stickySummaryObserver = new IntersectionObserver(function (entries) {
          handleStickySummaryVisibility();
        }, { root: null, threshold: 0 });
        stickySummaryObserver.observe(summaryEl);
        stickySummaryObserver.observe(addBtn);
        return;
      }
      window.addEventListener('scroll', function () {
        handleStickySummaryVisibility();
      }, { passive: true });
    }

    function classifyAddonToken(rawAddon) {
      var addonToken = String(rawAddon || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
      if (!addonToken) return '';
      if (addonToken === 'all-day-adventure' || addonToken === 'all-day' || addonToken === 'adventure' || addonToken.indexOf('all-day') === 0) {
        return 'adventure';
      }
      if (addonToken === 'uplift' || addonToken === 'uplift-bag' || addonToken === 'uplift-backpack' || addonToken.indexOf('uplift-') === 0) {
        return 'uplift';
      }
      return '';
    }

    function readUrlState() {
      var url = new URL(window.location.href);
      var rawAddon = String(url.searchParams.get('addon') || '').trim();
      if (!rawAddon && data && data.defaultAddon) rawAddon = String(data.defaultAddon);
      var addonIntent = classifyAddonToken(rawAddon);
      return {
        optionValues: (url.searchParams.get('option_values') || '').split(',').filter(Boolean),
        variantId: normalizeVariantId(url.searchParams.get('variant') || ''),
        bundleSetup: String(url.searchParams.get('bundle_setup') || '').trim(),
        addonIntent: addonIntent
      };
    }

    function writeCurrentUrl(url) {
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function writeStep1ToUrl(option) {
      if (state.suppressUrlSync) return;
      var url = new URL(window.location.href);
      var sizeOptionIndex = Number(data && data.sizeOptionIndex);
      if (isNaN(sizeOptionIndex)) sizeOptionIndex = 0;
      var optionValues = (url.searchParams.get('option_values') || '').split(',').filter(Boolean);
      if (option && option.optionValueId) {
        while (optionValues.length <= sizeOptionIndex) optionValues.push('');
        optionValues[sizeOptionIndex] = String(option.optionValueId);
        url.searchParams.set('option_values', optionValues.filter(Boolean).join(','));
      } else {
        url.searchParams.delete('option_values');
      }

      // Drop the legacy `variant` param so the URL stays clean; the native picker
      // re-resolves from option_values on load.
      url.searchParams.delete('variant');
      writeCurrentUrl(url);
    }

    function writeStep2ToUrl(selectedGroup) {
      if (state.suppressUrlSync) return;
      var url = new URL(window.location.href);
      if (!selectedGroup) {
        url.searchParams.delete('bundle_setup');
      } else {
        var setupKey = String((selectedGroup.key || selectedGroup.id || '')).trim();
        if (setupKey) url.searchParams.set('bundle_setup', setupKey);
      }
      writeCurrentUrl(url);
    }

    function getUpliftAddonHandle() {
      var rawUrl = String((twoStepUpliftData && twoStepUpliftData.productUrl) || '');
      var match = rawUrl.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }

    function writeUpliftAddonToUrl() {
      if (state.suppressUrlSync) return;
      if (!isTwoStepMode) return;
      var url = new URL(window.location.href);
      var addonValue = '';
      if (state.selectedTwoStepMode === 'uplift') {
        addonValue = getUpliftAddonHandle() || 'uplift';
        url.searchParams.set('addon', addonValue);
      } else if (state.selectedTwoStepMode === 'adventure') {
        addonValue = 'all-day-adventure';
        url.searchParams.set('addon', addonValue);
      } else {
        url.searchParams.delete('addon');
      }
      window.__krsPendingBundleAddon = addonValue;
      writeCurrentUrl(url);
    }

    function loadAddonData() {
      if (Array.isArray(data.addons) && data.addons.length) return data.addons;
      if (data._addonsLoaded) return Array.isArray(data.addons) ? data.addons : [];

      data._addonsLoaded = true;
      var addonsNodeId = data.addonsNodeId;
      if (!addonsNodeId) {
        data.addons = [];
        return data.addons;
      }
      var addonsNode = document.getElementById(String(addonsNodeId));
      if (!addonsNode) {
        data.addons = [];
        return data.addons;
      }

      perf.mark('addons-json-parse-start');
      try {
        var parsed = JSON.parse(addonsNode.textContent || '[]');
        data.addons = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        data.addons = [];
      }
      perf.mark('addons-json-parse-end');
      perf.measure('addons-json-parse', 'addons-json-parse-start', 'addons-json-parse-end');
      return data.addons;
    }

    function slugify(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function ensureGroupIds(groups) {
      var seen = {};
      return (groups || []).map(function (group, index) {
        var base =
          (group && group.id ? String(group.id) : '') ||
          (group && group.title ? slugify(group.title) : '') ||
          ('group-' + index);
        if (!seen[base]) {
          seen[base] = 1;
        } else {
          seen[base] += 1;
          base = base + '-' + seen[base];
        }
        var normalized = {};
        Object.keys(group || {}).forEach(function (key) { normalized[key] = group[key]; });
        normalized.id = base;
        normalized.key = normalized.key || base;
        return normalized;
      });
    }

    function getBaseProductImageForSelectedSize() {
      if (!state.selectedSize) return (data && data.baseProductImage) || '';
      var sizeOptions = getBundleSizeOptions();
      for (var i = 0; i < sizeOptions.length; i += 1) {
        var opt = sizeOptions[i];
        var label = getBundleSizeOptionLabel(opt);
        if (String(label) === String(state.selectedSize) && opt.imageUrl) return opt.imageUrl;
      }
      return (data && data.baseProductImage) || '';
    }

    function updateBaseProductThumbs() {
      var imgUrl = getBaseProductImageForSelectedSize();
      if (!imgUrl) return;
      var sep = imgUrl.indexOf('?') >= 0 ? '&' : '?';
      var src = imgUrl + sep + 'width=140';
      Array.prototype.forEach.call(
        groupsContainer.querySelectorAll('.krs-bundle-builder__group-thumb[data-group-image-source="base"] img'),
        function (img) {
          img.src = src;
          img.alt = (data && data.baseProductTitle) || 'Base product';
        }
      );
    }

    function normalizeImagePath(urlValue) {
      if (!urlValue) return '';
      try {
        var parsed = new URL(String(urlValue), window.location.origin);
        return String(parsed.pathname || '').toLowerCase();
      } catch (e) {
        return String(urlValue || '').split('?')[0].toLowerCase();
      }
    }

    function resolveMediaTargetId(mediaGallery, sectionId, selectedOption) {
      if (!mediaGallery || !selectedOption) return '';

      var mediaId = selectedOption.mediaId ? String(selectedOption.mediaId) : '';
      if (mediaId) {
        var explicitTarget = sectionId + '-' + mediaId;
        if (mediaGallery.querySelector('[data-media-id="' + explicitTarget + '"]')) {
          return explicitTarget;
        }
      }

      var optionImagePath = normalizeImagePath(selectedOption.imageUrl);
      if (!optionImagePath) return '';

      var mediaNodes = mediaGallery.querySelectorAll('[data-media-id]');
      for (var i = 0; i < mediaNodes.length; i += 1) {
        var node = mediaNodes[i];
        var img = node.querySelector('img');
        if (!img || !img.currentSrc && !img.src) continue;
        var nodeImagePath = normalizeImagePath(img.currentSrc || img.src);
        if (!nodeImagePath) continue;
        if (nodeImagePath === optionImagePath || nodeImagePath.indexOf(optionImagePath) >= 0 || optionImagePath.indexOf(nodeImagePath) >= 0) {
          return String(node.getAttribute('data-media-id') || '');
        }
      }

      return '';
    }

    function syncSelectedVariantMedia(selectedOption) {
      var option = selectedOption || null;
      if (!option) return false;
      var sectionHost = root.closest('[data-section]');
      if (!sectionHost || !sectionHost.dataset || !sectionHost.dataset.section) return false;
      var sectionId = String(sectionHost.dataset.section);
      if (!sectionId) return false;

      var mediaGallery = document.getElementById('MediaGallery-' + sectionId);
      if (!mediaGallery || typeof mediaGallery.setActiveMedia !== 'function') return false;
      var targetMediaId = resolveMediaTargetId(mediaGallery, sectionId, option);
      if (!targetMediaId) return false;
      var previousScrollY = window.scrollY || window.pageYOffset || 0;
      mediaGallery.dataset.skipScrollOnce = 'true';
      mediaGallery.setActiveMedia(targetMediaId, false);
      requestAnimationFrame(function () {
        var currentScrollY = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(currentScrollY - previousScrollY) > 1) {
          window.scrollTo(window.scrollX || 0, previousScrollY);
        }
      });
      return true;
    }

    function escapeSelectorValue(value) {
      if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(String(value));
      return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function normalizeOptionValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/["'`]/g, '')
        .replace(/\u201d|\u201c/g, '')
        .replace(/inch|in\./g, 'in')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getBundleSizeOptions() {
      return Array.isArray(data && data.sizeOptions) ? data.sizeOptions : [];
    }

    function getBundleSizeOptionLabel(option) {
      if (!option) return '';
      if (typeof option.label === 'object') {
        return String(option.label.value || option.label.name || option.label || '');
      }
      return String(option.label || '');
    }

    function findBundleSizeOptionByOptionValueId(optionValueId) {
      if (!optionValueId) return null;
      var target = String(optionValueId);
      var sizeOptions = getBundleSizeOptions();
      for (var i = 0; i < sizeOptions.length; i += 1) {
        var candidate = sizeOptions[i] && sizeOptions[i].optionValueId != null ? String(sizeOptions[i].optionValueId) : '';
        if (candidate && candidate === target) return sizeOptions[i];
      }
      return null;
    }

    function findBundleSizeOptionByVariantId(variantId) {
      var normalizedTarget = normalizeVariantId(variantId);
      if (!normalizedTarget) return null;
      var sizeOptions = getBundleSizeOptions();
      for (var i = 0; i < sizeOptions.length; i += 1) {
        var candidate = normalizeVariantId(sizeOptions[i] && sizeOptions[i].variantId);
        if (candidate && candidate === normalizedTarget) return sizeOptions[i];
      }
      return null;
    }

    function findBundleSizeOptionByLabel(label) {
      var normalizedTarget = normalizeOptionValue(label);
      if (!normalizedTarget) return null;
      var sizeOptions = getBundleSizeOptions();
      for (var i = 0; i < sizeOptions.length; i += 1) {
        var candidateLabel = getBundleSizeOptionLabel(sizeOptions[i]);
        if (normalizeOptionValue(candidateLabel) === normalizedTarget) return sizeOptions[i];
      }
      return null;
    }

    function findSizeButtonByLabel(label) {
      var normalizedTarget = normalizeOptionValue(label);
      if (!normalizedTarget || !sizeContainer) return null;
      var buttons = sizeContainer.querySelectorAll('.krs-bundle-builder__size-btn');
      for (var i = 0; i < buttons.length; i += 1) {
        var buttonLabel = buttons[i].getAttribute('data-size-label') || buttons[i].textContent || '';
        if (normalizeOptionValue(buttonLabel) === normalizedTarget) return buttons[i];
      }
      return null;
    }

    function resolveBundleSelectionOption(selectedOption, selectedLabel) {
      var providedOption = selectedOption || {};
      var resolvedLabel = selectedLabel != null ? String(selectedLabel) : '';
      if (!resolvedLabel) resolvedLabel = getBundleSizeOptionLabel(providedOption);

      var merged = {};
      var optionValueId = providedOption.optionValueId;
      var variantId = normalizeVariantId(providedOption.variantId);
      var resolvedFromData = null;

      if (optionValueId) {
        resolvedFromData = findBundleSizeOptionByOptionValueId(optionValueId);
      }
      if (!resolvedFromData && variantId) {
        resolvedFromData = findBundleSizeOptionByVariantId(variantId);
      }
      if (!resolvedFromData && resolvedLabel) {
        resolvedFromData = findBundleSizeOptionByLabel(resolvedLabel);
      }

      if (resolvedFromData) {
        Object.keys(resolvedFromData).forEach(function (key) {
          merged[key] = resolvedFromData[key];
        });
      }
      Object.keys(providedOption).forEach(function (key) {
        if (providedOption[key] !== undefined) merged[key] = providedOption[key];
      });
      if (!merged.label && resolvedLabel) merged.label = resolvedLabel;

      if (!merged.optionValueId || !normalizeVariantId(merged.variantId)) {
        var button = findSizeButtonByLabel(merged.label || resolvedLabel);
        if (button) {
          if (!merged.optionValueId) {
            var buttonOptionValueId = button.getAttribute('data-option-value-id');
            if (buttonOptionValueId) merged.optionValueId = buttonOptionValueId;
          }
          if (!normalizeVariantId(merged.variantId)) {
            var buttonVariantId = normalizeVariantId(button.getAttribute('data-variant-id'));
            if (buttonVariantId) merged.variantId = buttonVariantId;
          }
        }
      }

      return merged;
    }

    function preserveScrollAroundVariantSwap() {
      // The native picker triggers an async section swap (fetchAndSwapMainSection)
      // which replaces the entire MainProduct DOM and re-inserts a new media-gallery.
      // The replacement + image load + scroll anchoring can shift the viewport.
      // Capture the current scroll position and restore it right after the swap
      // completes (signalled via the variantChange pub/sub event), plus a couple
      // of follow-up rAFs to cover the new media gallery mounting and the first
      // image paint.
      var startY = window.scrollY || window.pageYOffset || 0;
      var startX = window.scrollX || window.pageXOffset || 0;

      function restoreIfDrifted() {
        var y = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(y - startY) > 1) {
          window.scrollTo(startX, startY);
        }
      }

      var unsubscribed = false;
      var unsub = null;
      function teardown() {
        if (unsubscribed) return;
        unsubscribed = true;
        if (typeof unsub === 'function') {
          try { unsub(); } catch (e) {}
        }
      }

      function onVariantChanged() {
        restoreIfDrifted();
        requestAnimationFrame(function () {
          restoreIfDrifted();
          requestAnimationFrame(restoreIfDrifted);
        });
        setTimeout(restoreIfDrifted, 120);
        setTimeout(teardown, 260);
      }

      try {
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          unsub = subscribe(PUB_SUB_EVENTS.variantChange, onVariantChanged);
        }
      } catch (e) {
        unsub = null;
      }

      setTimeout(teardown, 1500);
    }

    function syncBundleSelectionWithNativeFlow(selectedOption, selectedLabel) {
      var resolvedOption = resolveBundleSelectionOption(selectedOption, selectedLabel);
      var resolvedLabel = selectedLabel != null ? String(selectedLabel) : '';
      if (!resolvedLabel && resolvedOption && resolvedOption.label) resolvedLabel = String(resolvedOption.label);

      preserveScrollAroundVariantSwap();

      var nativeSynced = false;
      try {
        nativeSynced = syncNativeVariantSelection(resolvedOption, resolvedLabel);
      } catch (e) {
        root.setAttribute('data-krs-bundle-debug', 'native-sync-error');
      }

      if (!state.selectedVariantId) syncStateVariantFromNativeForm();

      if (!nativeSynced) {
        var mediaSynced = syncSelectedVariantMedia(resolvedOption);
        if (!mediaSynced) {
          root.setAttribute('data-krs-bundle-debug', 'bundle-media-sync-failed');
        }
      }

      if (nativeSynced) {
        // Native picker updates hidden variant input; sync again next tick.
        setTimeout(function () {
          if (syncStateVariantFromNativeForm()) {
            updateStep2Visibility();
            updateStep3Visibility();
            formatSummary();
          }
        }, 0);
      }

      return nativeSynced;
    }

    function findRadioByOptionValueId(scope, optionValueId) {
      if (!scope || !optionValueId) return null;
      var target = String(optionValueId);
      var radios = scope.querySelectorAll('input[type="radio"][data-option-value-id]');
      for (var i = 0; i < radios.length; i += 1) {
        var candidate = radios[i].getAttribute('data-option-value-id');
        if (candidate != null && String(candidate) === target) return radios[i];
      }
      return null;
    }

    function findOptionByOptionValueId(scope, optionValueId) {
      if (!scope || !optionValueId) return null;
      var target = String(optionValueId);
      var options = scope.querySelectorAll('option[data-option-value-id]');
      for (var i = 0; i < options.length; i += 1) {
        var candidate = options[i].getAttribute('data-option-value-id');
        if (candidate != null && String(candidate) === target) return options[i];
      }
      return null;
    }

    function forceNativeSectionSwap(pickerRoot, option, sizeOptionIndex) {
      if (!pickerRoot || typeof pickerRoot.fetchAndSwapMainSection !== 'function') return false;
      var destinationSectionId = pickerRoot.dataset && pickerRoot.dataset.section ? String(pickerRoot.dataset.section) : '';
      if (!destinationSectionId) return false;
      var sectionId = pickerRoot.dataset && pickerRoot.dataset.originalSection
        ? String(pickerRoot.dataset.originalSection)
        : destinationSectionId;

      var optionValueIds = typeof pickerRoot.getSelectedOptionValueIds === 'function'
        ? pickerRoot.getSelectedOptionValueIds().slice()
        : [];

      if (option && option.optionValueId) {
        while (optionValueIds.length <= sizeOptionIndex) optionValueIds.push('');
        optionValueIds[sizeOptionIndex] = String(option.optionValueId);
        optionValueIds = optionValueIds.filter(Boolean);
      }

      var targetProductUrl = (pickerRoot.dataset && pickerRoot.dataset.url) ? String(pickerRoot.dataset.url) : window.location.pathname;
      if (option && option.optionValueId) {
        var radioControl = findRadioByOptionValueId(pickerRoot, option.optionValueId);
        var optionControl = radioControl ? null : findOptionByOptionValueId(pickerRoot, option.optionValueId);
        if (radioControl && radioControl.dataset && radioControl.dataset.productUrl) {
          targetProductUrl = radioControl.dataset.productUrl;
        } else if (optionControl && optionControl.dataset && optionControl.dataset.productUrl) {
          targetProductUrl = optionControl.dataset.productUrl;
        }
      }

      pickerRoot.fetchAndSwapMainSection({
        sectionId: sectionId,
        destinationSectionId: destinationSectionId,
        targetProductUrl: targetProductUrl,
        optionValueIds: optionValueIds,
        focusId: ''
      });
      return true;
    }

    function forceSectionSwapWithoutPicker(option, sizeOptionIndex, sectionId) {
      if (!option || !option.optionValueId || !sectionId) return false;
      var destination = document.getElementById('MainProduct-' + sectionId);
      if (!destination) return false;

      var currentUrl = new URL(window.location.href);
      var optionValueIds = (currentUrl.searchParams.get('option_values') || '').split(',').filter(Boolean);
      while (optionValueIds.length <= sizeOptionIndex) optionValueIds.push('');
      optionValueIds[sizeOptionIndex] = String(option.optionValueId);
      optionValueIds = optionValueIds.filter(Boolean);
      if (!optionValueIds.length) return false;

      var targetProductUrl = option.optionProductUrl ? String(option.optionProductUrl) : currentUrl.pathname;
      var fetchUrl = new URL(targetProductUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      fetchUrl.searchParams.set('option_values', optionValueIds.join(','));

      fetch(fetchUrl.toString(), { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var source = html.getElementById('MainProduct-' + sectionId);
          if (!source) return;
          var currentDestination = document.getElementById('MainProduct-' + sectionId);
          if (!currentDestination) return;
          currentDestination.replaceWith(source);

          var browserUrl = new URL(targetProductUrl, window.location.origin);
          browserUrl.searchParams.set('option_values', optionValueIds.join(','));
          window.history.replaceState({}, '', browserUrl.pathname + browserUrl.search + browserUrl.hash);
        })
        .catch(function () {
          root.setAttribute('data-krs-bundle-debug', 'native-sync-failed-no-picker-root');
        });
      return true;
    }

    function getMainProductContainer(sectionId, sectionHost) {
      var mainById = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
      if (mainById) return mainById;
      var fromHost = sectionHost && sectionHost.closest ? sectionHost.closest('[id^="MainProduct-"]') : null;
      if (fromHost) return fromHost;
      return root.closest ? root.closest('[id^="MainProduct-"]') : null;
    }

    function parseSectionIdFromNode(node) {
      if (!node) return '';
      if (node.dataset && node.dataset.section) return String(node.dataset.section);
      if (node.id && node.id.indexOf('variant-radios-') === 0) return String(node.id.replace('variant-radios-', ''));
      if (node.id && node.id.indexOf('variant-selects-') === 0) return String(node.id.replace('variant-selects-', ''));
      return '';
    }

    function syncNativeVariantSelection(selectedOption, selectedLabel) {
      var option = selectedOption || {};
      var label = selectedLabel != null ? String(selectedLabel) : '';
      var normalizedLabel = normalizeOptionValue(label);
      var sizeOptionIndex = Number(data && data.sizeOptionIndex);
      if (isNaN(sizeOptionIndex)) sizeOptionIndex = 0;
      var sectionHost = root.closest('[data-section]');
      if (!sectionHost || !sectionHost.dataset || !sectionHost.dataset.section) return false;
      var sectionId = String(sectionHost.dataset.section);
      if (!sectionId) return false;
      var mainProduct = getMainProductContainer(sectionId, sectionHost);

      function getPreferredVariantRoot(tagName) {
        function isSectionMatch(node) {
          if (!node || !node.dataset) return false;
          var ds = node.dataset.section ? String(node.dataset.section) : '';
          var os = node.dataset.originalSection ? String(node.dataset.originalSection) : '';
          return ds === sectionId || os === sectionId;
        }

        function pickBest(nodes) {
          if (!nodes || !nodes.length) return null;
          for (var i = 0; i < nodes.length; i += 1) {
            if (nodes[i].dataset && nodes[i].dataset.updateUrl === 'false') continue;
            return nodes[i];
          }
          return nodes[0];
        }

        var allNodes = Array.prototype.slice.call(document.querySelectorAll(tagName));
        if (mainProduct) {
          var inMainProduct = allNodes.filter(function (node) { return mainProduct.contains(node); });
          var inMainProductBest = pickBest(inMainProduct);
          if (inMainProductBest) return inMainProductBest;
        }

        var matching = allNodes.filter(isSectionMatch);
        if (!matching.length) return null;

        var productInfo = document.getElementById('ProductInfo-' + sectionId);
        if (productInfo) {
          var scoped = matching.filter(function (node) { return productInfo.contains(node); });
          var scopedBest = pickBest(scoped);
          if (scopedBest) return scopedBest;
        }

        var sectionRoot = document.getElementById('MainProduct-' + sectionId);
        if (sectionRoot) {
          var inSection = matching.filter(function (node) { return sectionRoot.contains(node); });
          var inSectionBest = pickBest(inSection);
          if (inSectionBest) return inSectionBest;
        }

        return pickBest(matching);
      }

      var radiosRoot = getPreferredVariantRoot('variant-radios');
      if (radiosRoot) {
        var radio = null;
        if (option.optionValueId) {
          // Option-value IDs are authoritative; search the entire native picker first.
          radio = findRadioByOptionValueId(radiosRoot, option.optionValueId);
        }
        var radioScope = radiosRoot;
        var radioFieldsets = radiosRoot.querySelectorAll('fieldset');
        if (!radio && radioFieldsets && radioFieldsets.length > sizeOptionIndex) {
          radioScope = radioFieldsets[sizeOptionIndex];
        }
        if (!radio && label) {
          radio = radioScope.querySelector('input[type="radio"][value="' + escapeSelectorValue(label) + '"]');
        }
        if (!radio && normalizedLabel) {
          var radioCandidates = radioScope.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radioCandidates.length; i += 1) {
            var candidateValue = normalizeOptionValue(radioCandidates[i].value);
            if (candidateValue === normalizedLabel) {
              radio = radioCandidates[i];
              break;
            }
          }
        }
        if (radio) {
          // Skip dispatching change when the radio is already selected to avoid
          // redundant native section swaps that shift the viewport.
          if (radio.checked) {
            return true;
          }
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }

      var selectsRoot = getPreferredVariantRoot('variant-selects');
      if (selectsRoot) {
        var select = selectsRoot.querySelectorAll('select')[sizeOptionIndex] || selectsRoot.querySelector('select');
        if (!select) return false;

        var selectOption = null;
        if (option.optionValueId) {
          // Option-value IDs are authoritative; search all picker selects first.
          selectOption = findOptionByOptionValueId(selectsRoot, option.optionValueId);
          if (selectOption) {
            var ownerSelect = selectOption.closest('select');
            if (ownerSelect) {
              select = ownerSelect;
            }
          }
        }
        if (!selectOption && label) {
          selectOption = select.querySelector('option[value="' + escapeSelectorValue(label) + '"]');
        }
        if (!selectOption && normalizedLabel) {
          var optionCandidates = select.querySelectorAll('option');
          for (var j = 0; j < optionCandidates.length; j += 1) {
            var optionValueNormalized = normalizeOptionValue(optionCandidates[j].value);
            if (optionValueNormalized === normalizedLabel) {
              selectOption = optionCandidates[j];
              break;
            }
          }
        }
        if (!selectOption) return false;

        // Skip dispatching change when the select already matches to avoid
        // redundant native section swaps that shift the viewport.
        if (select.value === selectOption.value) {
          return true;
        }
        select.value = selectOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      var fallbackPickerRoot = radiosRoot || selectsRoot;
      if (fallbackPickerRoot && forceNativeSectionSwap(fallbackPickerRoot, option, sizeOptionIndex)) {
        root.setAttribute('data-krs-bundle-debug', 'native-sync-fallback-section-swap');
        return true;
      }

      if (!fallbackPickerRoot) {
        var fallbackInContainer = null;
        if (mainProduct) {
          fallbackInContainer = mainProduct.querySelector('variant-radios, variant-selects');
        }
        if (fallbackInContainer) {
          if (!fallbackInContainer.getAttribute('data-section')) {
            var parsedSectionId = parseSectionIdFromNode(fallbackInContainer);
            if (parsedSectionId) {
              fallbackInContainer.setAttribute('data-section', parsedSectionId);
            }
          }
          if (forceNativeSectionSwap(fallbackInContainer, option, sizeOptionIndex)) {
            root.setAttribute('data-krs-bundle-debug', 'native-sync-fallback-container-swap');
            return true;
          }
        }
        if (NO_PICKER_SWAP_ENABLED && forceSectionSwapWithoutPicker(option, sizeOptionIndex, sectionId)) {
          root.setAttribute('data-krs-bundle-debug', 'native-sync-fallback-no-picker-swap');
          return true;
        }
        root.setAttribute('data-krs-bundle-debug', 'native-sync-failed-no-picker-root');
        return false;
      }

      if (!option.optionValueId) {
        root.setAttribute('data-krs-bundle-debug', 'native-sync-failed-missing-option-value-id');
      } else {
        root.setAttribute('data-krs-bundle-debug', 'native-sync-failed');
      }
      return false;
    }

    function normalizeVariantId(raw) {
      if (raw === null || raw === undefined) return null;
      var value = String(raw).trim();
      if (!value) return null;
      if (/^\d+$/.test(value)) return value;
      var gidMatch = value.match(/\/(\d+)(?:\?.*)?$/);
      if (gidMatch && gidMatch[1]) return gidMatch[1];
      return null;
    }

    function getCurrentVariantIdFromNativeForm() {
      var mainProduct = root.closest('[id^="MainProduct-"]');
      if (!mainProduct) return null;
      var input = mainProduct.querySelector('product-form form input[name="id"]');
      if (!input || !input.value) return null;
      return normalizeVariantId(input.value);
    }

    function syncStateVariantFromNativeForm() {
      var nativeVariantId = getCurrentVariantIdFromNativeForm();
      if (!nativeVariantId) return false;
      state.selectedVariantId = nativeVariantId;
      return true;
    }

    function setAddButtonDisabled(isDisabled) {
      addBtn.disabled = !!isDisabled;
      if (isDisabled) {
        addBtn.setAttribute('aria-disabled', 'true');
      } else {
        addBtn.removeAttribute('aria-disabled');
      }
      syncStickySummary();
    }

    function resolveBikeOnlyTitle(sizeLabel) {
      var baseTitle = String((data && data.baseProductTitle) || 'Dirt Hero').trim() || 'Dirt Hero';
      if (!isTwoStepMode) return 'Bike only';
      var normalized = normalizeTwoStepLabel(sizeLabel || state.selectedSize || '');
      if (normalized.indexOf('12') >= 0) return '12" ' + baseTitle;
      if (normalized.indexOf('14') >= 0) return '14" ' + baseTitle;
      return baseTitle;
    }

    function normalizePackageTitle(title, sizeLabel) {
      var value = String(title || '').trim();
      var normalizedValue = value.toLowerCase();
      if (!value) return resolveBikeOnlyTitle(sizeLabel);
      if (normalizedValue === 'base product only' || normalizedValue === 'bike only') return resolveBikeOnlyTitle(sizeLabel);
      return value;
    }

    function normalizeTwoStepLabel(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[\u201c\u201d]/g, '"')
        .replace(/["'`]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function normalizeSku(value) {
      return String(value || '').trim().toUpperCase();
    }

    function getTwoStepUpliftConfig() {
      var uplift = twoStepUpliftData || {};
      var variantId = normalizeVariantId(uplift.variantId);
      var isAvailable = typeof uplift.available === 'boolean' ? uplift.available : !!variantId;
      var isConfigured = typeof uplift.configured === 'boolean' ? uplift.configured : !!variantId;
      return {
        headingLabel: String(uplift.headingLabel || tStr('addTheUpliftDefault', 'Add the Uplift')),
        description: String(uplift.description || ''),
        productDescriptionHtml: String(uplift.productDescriptionHtml || ''),
        productTitle: String(uplift.productTitle || tStr('upliftProductFallback', 'Uplift Backpack')),
        cardTitle: String(uplift.cardTitle || uplift.productTitle || tStr('upliftProductFallback', 'Uplift Backpack')),
        productUrl: String(uplift.productUrl || ''),
        configured: !!isConfigured,
        variantId: variantId,
        sku: normalizeSku(uplift.sku || UPLIFT_ADDON_SKU),
        imageUrl: String(uplift.imageUrl || ''),
        priceCents: Number(uplift.priceCents || 0),
        compareAtCents: Number(uplift.compareAtCents || 0),
        available: !!(isAvailable && variantId)
      };
    }

    function getUpliftAddonConfig() {
      if (!isTwoStepMode) return null;
      var uplift = getTwoStepUpliftConfig();
      if (!uplift.configured) return null;
      var matchedVariantId = normalizeVariantId(uplift.variantId);
      if (!matchedVariantId) return null;
      return {
        group: null,
        product: null,
        variantId: matchedVariantId,
        sku: normalizeSku(uplift.sku),
        title: String(uplift.productTitle || tStr('upliftProductFallback', 'Uplift Backpack')),
        priceCents: Number(uplift.priceCents || 0),
        compareAtCents: Number(uplift.compareAtCents || 0),
        imageUrl: String(uplift.imageUrl || ''),
        available: !!(uplift.available && matchedVariantId)
      };
    }

    function getAdventureConfig() {
      var adventure = twoStepAdventureData || {};
      var variantId = normalizeVariantId(adventure.variantId);
      var uplift = getTwoStepUpliftConfig();
      var bagDiscount = Number(adventure.bagDiscountCents);
      if (!isFinite(bagDiscount) || bagDiscount < 0) bagDiscount = 0;
      if (!bagDiscount && adventure.bagDiscountCents !== 0 && adventure.bagDiscountCents !== '0') {
        bagDiscount = getTwoStepUpliftDiscountCents();
      }
      var ropeDiscount = Number(adventure.towRopeDiscountCents || 0);
      if (!isFinite(ropeDiscount) || ropeDiscount < 0) ropeDiscount = 0;
      var ropePrice = Number(adventure.priceCents || 0);
      var bagPrice = Number(adventure.bagPriceCents || uplift.priceCents || 0);
      var configured = typeof adventure.configured === 'boolean' ? adventure.configured : !!variantId;
      var available = typeof adventure.available === 'boolean' ? adventure.available : !!(configured && variantId);
      return {
        configured: !!configured,
        available: !!(available && variantId && uplift.available),
        variantId: variantId,
        sku: normalizeSku(adventure.sku || ''),
        title: String(adventure.title || 'All Day Adventure Bundle'),
        subtitle: String(adventure.subtitle || ''),
        imageUrl: String(adventure.imageUrl || ''),
        towRopeTitle: String(adventure.towRopeTitle || 'Tow Rope'),
        priceCents: ropePrice,
        bagPriceCents: bagPrice,
        bagDiscountCents: bagDiscount,
        towRopeDiscountCents: ropeDiscount
      };
    }

    function getAdventureDisplayCents(adventure) {
      var config = adventure || getAdventureConfig();
      var bagPay = Math.max(0, Number(config.bagPriceCents || 0) - Number(config.bagDiscountCents || 0));
      var ropePay = Math.max(0, Number(config.priceCents || 0) - Number(config.towRopeDiscountCents || 0));
      var compare = Math.max(0, Number(config.bagPriceCents || 0) + Number(config.priceCents || 0));
      var current = bagPay + ropePay;
      return {
        bagPay: bagPay,
        ropePay: ropePay,
        compare: compare,
        current: current,
        savings: Math.max(0, compare - current)
      };
    }

    function getTwoStepUpliftTitle() {
      var uplift = getTwoStepUpliftConfig();
      return String(uplift.headingLabel || 'Add the Uplift');
    }

    function setUpliftModalActiveDot(activeIndex) {
      if (!upliftModal) return;
      var dots = upliftModal.querySelectorAll('[data-uplift-modal-dot-index]');
      if (!dots || !dots.length) return;
      Array.prototype.forEach.call(dots, function (dotButton, index) {
        var isActive = index + 1 === activeIndex;
        dotButton.classList.toggle('product-media-gallery__dot--active', isActive);
        dotButton.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      var prevButton = upliftModal.querySelector('[data-uplift-modal-prev]');
      var nextButton = upliftModal.querySelector('[data-uplift-modal-next]');
      if (prevButton) prevButton.disabled = activeIndex <= 1;
      if (nextButton) nextButton.disabled = activeIndex >= dots.length;
    }

    function syncUpliftModalActiveDotFromSlider() {
      if (!upliftModal) return;
      var slider = upliftModal.querySelector('[data-role="uplift-modal-slider"]');
      if (!slider) return;
      var slides = slider.querySelectorAll('[data-uplift-modal-slide-index]');
      if (!slides || !slides.length) return;
      var sliderLeft = slider.scrollLeft || 0;
      var closestIndex = 1;
      var minDistance = Infinity;
      Array.prototype.forEach.call(slides, function (slideNode, index) {
        var distance = Math.abs((slideNode.offsetLeft || 0) - sliderLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index + 1;
        }
      });
      setUpliftModalActiveDot(closestIndex);
    }

    function scrollUpliftModalSliderTo(index) {
      if (!upliftModal) return;
      var slider = upliftModal.querySelector('[data-role="uplift-modal-slider"]');
      if (!slider) return;
      var slides = slider.querySelectorAll('[data-uplift-modal-slide-index]');
      if (!slides || !slides.length) return;
      var target = slides[Math.max(0, Math.min(slides.length - 1, Number(index || 1) - 1))];
      if (!target) return;
      slider.scrollTo({ left: target.offsetLeft || 0, behavior: 'smooth' });
      setUpliftModalActiveDot(Number(index || 1));
    }

    function setupUpliftModalGallery() {
      if (!upliftModal || upliftModal.__krsUpliftGalleryBound) return;
      upliftModal.__krsUpliftGalleryBound = true;
      var slider = upliftModal.querySelector('[data-role="uplift-modal-slider"]');
      if (!slider) return;

      Array.prototype.forEach.call(upliftModal.querySelectorAll('[data-uplift-modal-dot-index]'), function (dotButton) {
        dotButton.addEventListener('click', function () {
          var index = Number(dotButton.getAttribute('data-uplift-modal-dot-index') || 0);
          if (!index) return;
          scrollUpliftModalSliderTo(index);
        });
      });

      var prevButton = upliftModal.querySelector('[data-uplift-modal-prev]');
      var nextButton = upliftModal.querySelector('[data-uplift-modal-next]');
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          var dots = upliftModal.querySelectorAll('[data-uplift-modal-dot-index]');
          if (!dots || !dots.length) return;
          var current = 1;
          Array.prototype.forEach.call(dots, function (dotButton, index) {
            if (dotButton.classList.contains('product-media-gallery__dot--active')) current = index + 1;
          });
          scrollUpliftModalSliderTo(Math.max(1, current - 1));
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          var dots = upliftModal.querySelectorAll('[data-uplift-modal-dot-index]');
          if (!dots || !dots.length) return;
          var current = 1;
          Array.prototype.forEach.call(dots, function (dotButton, index) {
            if (dotButton.classList.contains('product-media-gallery__dot--active')) current = index + 1;
          });
          scrollUpliftModalSliderTo(Math.min(dots.length, current + 1));
        });
      }

      var onScroll = function () {
        if (slider.__krsUpliftScrollTicking) return;
        slider.__krsUpliftScrollTicking = true;
        requestAnimationFrame(function () {
          slider.__krsUpliftScrollTicking = false;
          syncUpliftModalActiveDotFromSlider();
        });
      };
      slider.addEventListener('scroll', onScroll, { passive: true });

      window.addEventListener('resize', function () {
        syncUpliftModalActiveDotFromSlider();
      });
      syncUpliftModalActiveDotFromSlider();
    }

    function syncUpliftModalContent() {
      if (!upliftModal) return;
      var upliftConfig = getTwoStepUpliftConfig();
      var upliftCard = groupsContainer ? groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="uplift"]') : null;

      var modalTitle = upliftModal.querySelector('[data-role="uplift-modal-title"]');
      var modalDescription = upliftModal.querySelector('[data-role="uplift-modal-description"]');
      var modalCurrentDollars = upliftModal.querySelector('[data-role="uplift-modal-current-dollars"]');
      var modalCurrentCents = upliftModal.querySelector('[data-role="uplift-modal-current-cents"]');
      var modalCurrentDollarsRegular = upliftModal.querySelector('[data-role="uplift-modal-current-dollars-regular"]');
      var modalCurrentCentsRegular = upliftModal.querySelector('[data-role="uplift-modal-current-cents-regular"]');
      var modalPriceRoot = upliftModal.querySelector('[data-role="uplift-modal-price"]');
      var modalSaleNode = upliftModal.querySelector('[data-role="uplift-modal-sale-price"]');
      var modalRegularNode = upliftModal.querySelector('[data-role="uplift-modal-regular-price"]');
      var modalCompareNode = upliftModal.querySelector('[data-role="uplift-modal-compare-price"]');
      var modalCompareDollars = upliftModal.querySelector('[data-role="uplift-modal-compare-dollars"]');
      var modalCompareCents = upliftModal.querySelector('[data-role="uplift-modal-compare-cents"]');
      var modalLink = upliftModal.querySelector('[data-role="uplift-modal-link"]');

      if (upliftCard) {
        var cardTitle = upliftCard.querySelector('[data-role="group-product-title"]');
        var cardCurrentDollars = upliftCard.querySelector('[data-role="group-current-dollars"]');
        var cardCurrentCents = upliftCard.querySelector('[data-role="group-current-cents"]');
        var cardCompareNode = upliftCard.querySelector('[data-role="group-compare-price"]');
        var cardCompareDollars = upliftCard.querySelector('[data-role="group-compare-dollars"]');
        var cardCompareCents = upliftCard.querySelector('[data-role="group-compare-cents"]');

        if (modalTitle) {
          modalTitle.textContent = cardTitle ? String(cardTitle.textContent || '').trim() : String(upliftConfig.productTitle || '');
        }
        var displayPriceFromCard = {
          dollars: cardCurrentDollars ? String(cardCurrentDollars.textContent || '').trim() : formatMoneyParts(getTwoStepUpliftDisplayPriceCents(upliftConfig.priceCents)).dollars,
          cents: cardCurrentCents ? String(cardCurrentCents.textContent || '').trim() : formatMoneyParts(getTwoStepUpliftDisplayPriceCents(upliftConfig.priceCents)).cents
        };
        if (modalCurrentDollars) modalCurrentDollars.textContent = displayPriceFromCard.dollars;
        if (modalCurrentCents) modalCurrentCents.textContent = displayPriceFromCard.cents;
        if (modalCurrentDollarsRegular) modalCurrentDollarsRegular.textContent = displayPriceFromCard.dollars;
        if (modalCurrentCentsRegular) modalCurrentCentsRegular.textContent = displayPriceFromCard.cents;

        if (modalCompareNode && modalCompareDollars && modalCompareCents) {
          var compareVisible = !!(cardCompareNode && cardCompareNode.style.display !== 'none');
          if (compareVisible) {
            modalCompareDollars.textContent = cardCompareDollars ? String(cardCompareDollars.textContent || '').trim() : formatMoneyParts(upliftConfig.compareAtCents || 0).dollars;
            modalCompareCents.textContent = cardCompareCents ? String(cardCompareCents.textContent || '').trim() : formatMoneyParts(upliftConfig.compareAtCents || 0).cents;
            if (modalPriceRoot) modalPriceRoot.classList.add('price--on-sale');
            if (modalSaleNode) modalSaleNode.style.display = '';
            if (modalRegularNode) modalRegularNode.style.display = 'none';
          } else {
            if (modalPriceRoot) modalPriceRoot.classList.remove('price--on-sale');
            if (modalSaleNode) modalSaleNode.style.display = 'none';
            if (modalRegularNode) modalRegularNode.style.display = '';
          }
        }
      } else {
        var defaultDisplayPriceCents = getTwoStepUpliftDisplayPriceCents(upliftConfig.priceCents);
        var defaultDisplayCompareCents = Number(upliftConfig.compareAtCents || 0);
        var defaultPriceParts = formatMoneyParts(defaultDisplayPriceCents);
        var defaultCompareParts = formatMoneyParts(defaultDisplayCompareCents);
        if (modalTitle) modalTitle.textContent = String(upliftConfig.productTitle || '');
        if (modalCurrentDollars) modalCurrentDollars.textContent = defaultPriceParts.dollars;
        if (modalCurrentCents) modalCurrentCents.textContent = defaultPriceParts.cents;
        if (modalCurrentDollarsRegular) modalCurrentDollarsRegular.textContent = defaultPriceParts.dollars;
        if (modalCurrentCentsRegular) modalCurrentCentsRegular.textContent = defaultPriceParts.cents;
        if (modalCompareNode && modalCompareDollars && modalCompareCents) {
          if (defaultDisplayCompareCents > defaultDisplayPriceCents) {
            modalCompareDollars.textContent = defaultCompareParts.dollars;
            modalCompareCents.textContent = defaultCompareParts.cents;
            if (modalPriceRoot) modalPriceRoot.classList.add('price--on-sale');
            if (modalSaleNode) modalSaleNode.style.display = '';
            if (modalRegularNode) modalRegularNode.style.display = 'none';
          } else {
            if (modalPriceRoot) modalPriceRoot.classList.remove('price--on-sale');
            if (modalSaleNode) modalSaleNode.style.display = 'none';
            if (modalRegularNode) modalRegularNode.style.display = '';
          }
        }
      }

      if (modalDescription) {
        var productDescriptionHtml = String(upliftConfig.productDescriptionHtml || '').trim();
        if (productDescriptionHtml) {
          modalDescription.innerHTML = productDescriptionHtml;
          modalDescription.style.display = '';
        } else {
          modalDescription.innerHTML = '';
          modalDescription.style.display = 'none';
        }
      }

      if (modalLink) {
        var productUrl = String(upliftConfig.productUrl || '').trim();
        if (productUrl) {
          modalLink.setAttribute('href', productUrl);
          modalLink.style.display = '';
        } else {
          modalLink.setAttribute('href', '#');
          modalLink.style.display = 'none';
        }
      }
      syncUpliftModalActiveDotFromSlider();
    }

    function openUpliftModal() {
      if (!upliftModal) return;
      if (upliftModal.parentNode !== document.body) {
        if (!upliftModalOriginalParent) {
          upliftModalOriginalParent = upliftModal.parentNode;
          upliftModalOriginalNextSibling = upliftModal.nextSibling;
        }
        document.body.appendChild(upliftModal);
      }
      syncUpliftModalContent();
      setupUpliftModalGallery();
      upliftModalReturnFocusEl = document.activeElement && document.activeElement.focus ? document.activeElement : null;
      upliftModal.setAttribute('open', '');
      upliftModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('krs-bundle-builder__modal-open');
      scrollUpliftModalSliderTo(1);
      var dialog = upliftModal.querySelector('.krs-bundle-builder__modal-dialog');
      if (dialog && dialog.focus) {
        dialog.focus();
        return;
      }
      var closeButton = upliftModal.querySelector('.krs-bundle-builder__modal-close');
      if (closeButton && closeButton.focus) closeButton.focus();
    }

    function closeUpliftModal(restoreFocus) {
      if (!upliftModal || !upliftModal.hasAttribute('open')) return;
      upliftModal.removeAttribute('open');
      upliftModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('krs-bundle-builder__modal-open');
      if (restoreFocus && upliftModalReturnFocusEl && upliftModalReturnFocusEl.focus) {
        upliftModalReturnFocusEl.focus();
      }
      upliftModalReturnFocusEl = null;
    }

    function setupUpliftLearnMoreModal() {
      if (!step2LearnMoreBtn || !upliftModal || step2LearnMoreBtn.__krsUpliftModalBound) return;
      step2LearnMoreBtn.__krsUpliftModalBound = true;
      if (!upliftModalOriginalParent) {
        upliftModalOriginalParent = upliftModal.parentNode;
        upliftModalOriginalNextSibling = upliftModal.nextSibling;
      }

      step2LearnMoreBtn.addEventListener('click', function () {
        openUpliftModal();
      });

      Array.prototype.forEach.call(upliftModal.querySelectorAll('[data-uplift-modal-close]'), function (closeTarget) {
        closeTarget.addEventListener('click', function () {
          closeUpliftModal(true);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (!upliftModal || !upliftModal.hasAttribute('open')) return;
        if ((event && event.key) === 'Escape') {
          event.preventDefault();
          closeUpliftModal(true);
        }
      });
    }

    function getTwoStepHelmetConfig() {
      var helmet = twoStepHelmetData || {};
      var products = Array.isArray(helmet.products) ? helmet.products : [];
      return {
        configured: !!helmet.configured,
        headingLabel: String(helmet.headingLabel || 'Add a Helmet'),
        description: String(helmet.description || ''),
        discountCents: Number(helmet.discountCents || 0),
        products: products.map(function (p) {
          var rawVariants = Array.isArray(p && p.variants) ? p.variants : [];
          var rawOptions = Array.isArray(p && p.options) ? p.options : [];
          return {
            productId: String((p && p.productId) || ''),
            handle: String((p && p.handle) || ''),
            title: String((p && p.title) || 'Helmet'),
            url: String((p && p.url) || ''),
            imageUrl: String((p && p.imageUrl) || ''),
            options: rawOptions.map(function (o) {
              var values = Array.isArray(o && o.values) ? o.values : [];
              return {
                position: Number((o && o.position) || 0),
                name: String((o && o.name) || ''),
                values: values.map(function (v) { return String(v == null ? '' : v); })
              };
            }),
            variants: rawVariants.map(function (v) {
              var optionValues = Array.isArray(v && v.optionValues) ? v.optionValues.slice(0, 3) : [];
              return {
                variantId: normalizeVariantId(v && v.variantId),
                sku: String((v && v.sku) || ''),
                title: String((v && v.title) || ''),
                optionValues: optionValues.map(function (ov) { return String(ov == null ? '' : ov); }),
                imageUrl: String((v && v.imageUrl) || ''),
                priceCents: Number((v && v.priceCents) || 0),
                rawPriceCents: Number((v && v.rawPriceCents) || (v && v.priceCents) || 0),
                compareAtCents: Number((v && v.compareAtCents) || 0),
                available: !!(v && v.available)
              };
            })
          };
        })
      };
    }

    function getHelmetProductById(productId) {
      if (!productId) return null;
      var helmet = getTwoStepHelmetConfig();
      var target = String(productId);
      for (var i = 0; i < helmet.products.length; i += 1) {
        if (String(helmet.products[i].productId) === target) return helmet.products[i];
      }
      return null;
    }

    function findHelmetVariantByOptionValues(product, optionValues) {
      if (!product || !Array.isArray(product.variants)) return null;
      var picks = (optionValues || []).map(function (v) { return v == null ? '' : String(v); });
      for (var i = 0; i < product.variants.length; i += 1) {
        var variant = product.variants[i];
        if (!variant || !variant.variantId) continue;
        var matches = true;
        for (var j = 0; j < picks.length; j += 1) {
          if (picks[j] === '') continue;
          var variantValue = variant.optionValues[j] == null ? '' : String(variant.optionValues[j]);
          if (variantValue !== picks[j]) { matches = false; break; }
        }
        if (matches) return variant;
      }
      return null;
    }

    function resolveHelmetCardPicks(card) {
      if (!card) return [];
      var picks = [];
      Array.prototype.forEach.call(card.querySelectorAll('[data-helmet-option-index]'), function (group) {
        var idx = Number(group.getAttribute('data-helmet-option-index') || 0);
        if (!idx) return;
        var active = group.querySelector('.krs-bundle-builder__variant-swatch.is-selected');
        picks[idx - 1] = active ? String(active.getAttribute('data-value') || '') : '';
      });
      return picks;
    }

    function getHelmetCardDefaultVariant(product) {
      if (!product || !Array.isArray(product.variants)) return null;
      for (var i = 0; i < product.variants.length; i += 1) {
        if (product.variants[i] && product.variants[i].available) return product.variants[i];
      }
      return product.variants.length ? product.variants[0] : null;
    }

    function resetHelmetCardSwatches(card) {
      if (!card) return;
      Array.prototype.forEach.call(card.querySelectorAll('[data-helmet-swatch]'), function (swatch) {
        swatch.classList.remove('is-selected');
        swatch.setAttribute('aria-checked', 'false');
      });
    }

    function selectHelmetSwatchesForVariant(card, variant) {
      if (!card || !variant) return;
      resetHelmetCardSwatches(card);
      Array.prototype.forEach.call(card.querySelectorAll('[data-helmet-option-index]'), function (group) {
        var idx = Number(group.getAttribute('data-helmet-option-index') || 0);
        if (!idx) return;
        var value = variant.optionValues[idx - 1] == null ? '' : String(variant.optionValues[idx - 1]);
        if (!value) return;
        Array.prototype.forEach.call(group.querySelectorAll('[data-helmet-swatch]'), function (swatch) {
          if (String(swatch.getAttribute('data-value') || '') === value) {
            swatch.classList.add('is-selected');
            swatch.setAttribute('aria-checked', 'true');
          }
        });
      });
    }

    function selectDefaultHelmetSwatches(card) {
      if (!card) return;
      selectHelmetSwatchesForVariant(card, getHelmetCardDefaultVariant(getHelmetCardProduct(card)));
    }

    function restoreHelmetCardSwatchesFromState(card) {
      if (!card || card.getAttribute('data-helmet-pick-required') !== 'true') return;
      var product = getHelmetCardProduct(card);
      if (!product) return;
      var entry = state.selectedHelmets && state.selectedHelmets[String(product.productId)];
      if (!entry || !entry.variantId) return;
      var targetVariantId = normalizeVariantId(entry.variantId);
      var variant = null;
      for (var i = 0; i < product.variants.length; i += 1) {
        if (normalizeVariantId(product.variants[i].variantId) === targetVariantId) {
          variant = product.variants[i];
          break;
        }
      }
      if (variant) selectHelmetSwatchesForVariant(card, variant);
    }

    function syncHelmetCardSwatchesVisibility(card) {
      if (!card) return;
      var product = getHelmetCardProduct(card);
      if (!product) return;
      var productKey = String(product.productId);
      var selected = !!(state.selectedHelmets && state.selectedHelmets[productKey]);
      var swatchesEl = card.querySelector('[data-role="helmet-card-swatches"]');
      // Swatches stay rendered at all times to avoid layout shift; only the
      // selection state on individual swatch buttons is toggled below.
      if (swatchesEl && swatchesEl.hidden) swatchesEl.hidden = false;
      if (!selected) resetHelmetCardSwatches(card);
    }

    function getHelmetCardProduct(card) {
      if (!card) return null;
      return getHelmetProductById(card.getAttribute('data-helmet-product-id'));
    }

    function getHelmetCardResolvedVariant(card) {
      var product = getHelmetCardProduct(card);
      if (!product) return null;
      var pickRequired = card.getAttribute('data-helmet-pick-required') === 'true';
      var productKey = String(product.productId);
      var isSelected = !!(state.selectedHelmets && state.selectedHelmets[productKey]);
      if (!pickRequired) {
        if (!isSelected) return null;
        return getHelmetCardDefaultVariant(product);
      }
      if (!isSelected) return null;
      var picks = resolveHelmetCardPicks(card);
      var allPicked = picks.length > 0;
      for (var j = 0; j < picks.length; j += 1) {
        if (!picks[j]) { allPicked = false; break; }
      }
      if (!allPicked) return null;
      var match = findHelmetVariantByOptionValues(product, picks);
      if (!match) return null;
      return match.available ? match : null;
    }

    function formatHelmetMoneyParts(cents) {
      return formatMoneyParts(Math.max(0, Number(cents || 0)));
    }

    function paintHelmetCardPricing(card, variant) {
      if (!card) return;
      var pickRequired = card.getAttribute('data-helmet-pick-required') === 'true';
      var product = getHelmetCardProduct(card);
      var displayVariant = variant || getHelmetCardDefaultVariant(product);
      if (!displayVariant) return;

      var currentParts = formatHelmetMoneyParts(displayVariant.priceCents);
      var compareParts = formatHelmetMoneyParts(displayVariant.compareAtCents);
      var currentDollars = card.querySelector('[data-role="helmet-current-dollars"]');
      var currentCents = card.querySelector('[data-role="helmet-current-cents"]');
      var compareWrap = card.querySelector('[data-role="helmet-compare-price"]');
      var compareDollars = card.querySelector('[data-role="helmet-compare-dollars"]');
      var compareCents = card.querySelector('[data-role="helmet-compare-cents"]');
      var savingsBadge = card.querySelector('[data-role="helmet-savings-badge"]');
      if (currentDollars) currentDollars.textContent = currentParts.dollars;
      if (currentCents) currentCents.textContent = currentParts.cents;
      if (compareDollars) compareDollars.textContent = compareParts.dollars;
      if (compareCents) compareCents.textContent = compareParts.cents;
      var savingsCents = Math.max(0, Number(displayVariant.compareAtCents || 0) - Number(displayVariant.priceCents || 0));
      if (compareWrap) compareWrap.style.display = savingsCents > 0 ? '' : 'none';
      if (savingsBadge) {
        if (savingsCents > 0) {
          savingsBadge.textContent = tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savingsCents) });
          savingsBadge.style.display = '';
        } else {
          savingsBadge.textContent = '';
          savingsBadge.style.display = 'none';
        }
      }
      var thumbImg = card.querySelector('[data-role="helmet-card-thumb-img"]');
      if (thumbImg && displayVariant.imageUrl) thumbImg.setAttribute('src', displayVariant.imageUrl);
      var variantLabel = card.querySelector('[data-role="helmet-card-variant"]');
      if (variantLabel) {
        if (variant) {
          variantLabel.textContent = pickRequired
            ? variant.optionValues.filter(Boolean).join(' / ')
            : (variant.title || variant.optionValues.filter(Boolean).join(' / '));
          variantLabel.hidden = false;
        } else if (pickRequired) {
          variantLabel.textContent = '';
          variantLabel.hidden = true;
        } else {
          variantLabel.hidden = !variantLabel.textContent;
        }
      }
      card.setAttribute('data-price-cents', String(displayVariant.priceCents || 0));
      card.setAttribute('data-compare-cents', String(displayVariant.compareAtCents || 0));
      if (variant && variant.variantId) {
        card.setAttribute('data-variant-id', String(variant.variantId));
      } else {
        card.setAttribute('data-variant-id', String(card.getAttribute('data-default-variant-id') || ''));
      }
    }

    function applyHelmetCardSelection(card, opts) {
      if (!card) return;
      var product = getHelmetCardProduct(card);
      if (!product) return;
      var bikeSelected = !!state.selectedSize;
      var availableCount = Number(card.getAttribute('data-helmet-available-count') || 0);
      var productKey = String(product.productId);
      var isSelected = !!(state.selectedHelmets && state.selectedHelmets[productKey]);
      syncHelmetCardSwatchesVisibility(card);
      var resolvedVariant = getHelmetCardResolvedVariant(card);
      if (isSelected && !resolvedVariant) {
        restoreHelmetCardSwatchesFromState(card);
        resolvedVariant = getHelmetCardResolvedVariant(card);
      }
      var checkbox = card.querySelector('input[type="checkbox"][data-helmet-toggle-input]');
      var canEnableCheckbox = !!(bikeSelected && availableCount > 0);
      if (checkbox) checkbox.disabled = !canEnableCheckbox;
      card.classList.toggle('is-disabled', !canEnableCheckbox);
      card.setAttribute('aria-disabled', canEnableCheckbox ? 'false' : 'true');

      paintHelmetCardPricing(card, resolvedVariant);

      var pickRequired = card.getAttribute('data-helmet-pick-required') === 'true';
      var statusEl = card.querySelector('[data-role="helmet-card-status"]');
      if (statusEl) {
        if (pickRequired && bikeSelected && isSelected) {
          var picks = resolveHelmetCardPicks(card);
          var hasAnyPick = picks.some(Boolean);
          if (resolvedVariant) {
            statusEl.textContent = '';
            statusEl.hidden = true;
          } else if (!hasAnyPick) {
            statusEl.textContent = tStr('helmetPickVariantPrompt', 'Pick a variant to add');
            statusEl.hidden = false;
          } else if (findHelmetVariantByOptionValues(product, picks)) {
            statusEl.textContent = tStr('helmetVariantUnavailable', 'Out of stock');
            statusEl.hidden = false;
          } else {
            statusEl.textContent = tStr('helmetPickVariantPrompt', 'Pick a variant to add');
            statusEl.hidden = false;
          }
        } else {
          statusEl.textContent = '';
          statusEl.hidden = true;
        }
      }

      if (isSelected && resolvedVariant) {
        state.selectedHelmets[productKey] = buildHelmetSelectionEntry(product, resolvedVariant);
      }
      syncHelmetCardCheckedState(card);
      if (opts && opts.skipSummary) return;
      formatSummary();
    }

    function buildHelmetSelectionEntry(product, variant) {
      return {
        productId: String(product.productId),
        variantId: normalizeVariantId(variant.variantId),
        title: String(product.title || 'Helmet'),
        optionValue: variant.optionValues.filter(Boolean).join(' / '),
        priceCents: Number(variant.priceCents || 0),
        rawPriceCents: Number(variant.rawPriceCents || variant.priceCents || 0),
        compareAtCents: Number(variant.compareAtCents || 0),
        imageUrl: String(variant.imageUrl || product.imageUrl || '')
      };
    }

    function syncHelmetCardCheckedState(card) {
      if (!card) return;
      var product = getHelmetCardProduct(card);
      var selected = !!(product && state.selectedHelmets && state.selectedHelmets[String(product.productId)]);
      card.classList.toggle('is-selected', selected);
      var input = card.querySelector('input[type="checkbox"][data-helmet-toggle-input]');
      if (input) input.checked = selected;
    }

    function syncHelmetVisualSelection() {
      if (!helmetGroupsContainer) return;
      Array.prototype.forEach.call(helmetGroupsContainer.querySelectorAll('.krs-bundle-builder__group[data-helmet-card]'), function (card) {
        syncHelmetCardCheckedState(card);
      });
    }

    function updateHelmetAvailability() {
      if (!helmetGroupsContainer) return;
      Array.prototype.forEach.call(helmetGroupsContainer.querySelectorAll('.krs-bundle-builder__group[data-helmet-card]'), function (card) {
        applyHelmetCardSelection(card, { skipSummary: true });
      });
      if (stepHelmetContainer) {
        if (state.selectedSize) {
          stepHelmetContainer.classList.add('is-visible');
          stepHelmetContainer.style.display = '';
        } else {
          stepHelmetContainer.classList.remove('is-visible');
        }
      }
    }

    function clearHelmetSelectionExcept(activeProductKey) {
      Object.keys(state.selectedHelmets || {}).forEach(function (key) {
        if (String(key) === String(activeProductKey)) return;
        delete state.selectedHelmets[key];
      });
      if (!helmetGroupsContainer) return;
      Array.prototype.forEach.call(helmetGroupsContainer.querySelectorAll('.krs-bundle-builder__group[data-helmet-card]'), function (card) {
        var cardProduct = getHelmetCardProduct(card);
        if (!cardProduct) return;
        if (String(cardProduct.productId) === String(activeProductKey)) return;
        // Keep swatches rendered to avoid CLS; clear selection state on the
        // individual swatch buttons instead of hiding the container.
        resetHelmetCardSwatches(card);
      });
    }

    function refreshAllHelmetCards(opts) {
      opts = opts || {};
      if (!helmetGroupsContainer) return;
      Array.prototype.forEach.call(helmetGroupsContainer.querySelectorAll('.krs-bundle-builder__group[data-helmet-card]'), function (card) {
        applyHelmetCardSelection(card, { skipSummary: true });
      });
      if (!opts.skipSummary) formatSummary();
    }

    function toggleHelmetProduct(card) {
      if (!card) return;
      if (!state.selectedSize) return;
      var product = getHelmetCardProduct(card);
      if (!product) return;
      var productKey = String(product.productId);
      // Swatches stay rendered at all times (no .hidden toggling) to avoid CLS.
      // Selection is communicated via class/aria-checked on the swatch buttons.
      if (state.selectedHelmets[productKey]) {
        delete state.selectedHelmets[productKey];
        resetHelmetCardSwatches(card);
      } else {
        clearHelmetSelectionExcept(productKey);
        var resolvedVariant = null;
        if (card.getAttribute('data-helmet-pick-required') === 'true') {
          selectDefaultHelmetSwatches(card);
          var picks = resolveHelmetCardPicks(card);
          resolvedVariant = findHelmetVariantByOptionValues(product, picks);
          if (resolvedVariant && !resolvedVariant.available) resolvedVariant = null;
        } else {
          resolvedVariant = getHelmetCardDefaultVariant(product);
        }
        if (!resolvedVariant || !resolvedVariant.available) {
          resetHelmetCardSwatches(card);
          refreshAllHelmetCards();
          return;
        }
        state.selectedHelmets[productKey] = buildHelmetSelectionEntry(product, resolvedVariant);
      }
      refreshAllHelmetCards();
    }

    function bindHelmetCards() {
      if (!helmetGroupsContainer || helmetGroupsContainer.__krsHelmetBound) return;
      helmetGroupsContainer.__krsHelmetBound = true;
      var cards = helmetGroupsContainer.querySelectorAll('.krs-bundle-builder__group[data-helmet-card]');
      Array.prototype.forEach.call(cards, function (card) {
        var swatches = card.querySelectorAll('[data-helmet-swatch]');
        Array.prototype.forEach.call(swatches, function (swatch) {
          swatch.addEventListener('click', function (event) {
            if (event) event.preventDefault();
            if (swatch.disabled) return;
            if (!state.selectedSize) return;
            var product = getHelmetCardProduct(card);
            if (!product) return;
            var productKey = String(product.productId);
            var wasSelected = !!(state.selectedHelmets && state.selectedHelmets[productKey]);
            clearHelmetSelectionExcept(productKey);
            if (!wasSelected) {
              selectDefaultHelmetSwatches(card);
            }
            var optionIdx = swatch.getAttribute('data-option-index');
            var group = card.querySelector('[data-helmet-option-index="' + optionIdx + '"]');
            if (group) {
              Array.prototype.forEach.call(group.querySelectorAll('[data-helmet-swatch]'), function (sibling) {
                sibling.classList.remove('is-selected');
                sibling.setAttribute('aria-checked', 'false');
              });
            }
            swatch.classList.add('is-selected');
            swatch.setAttribute('aria-checked', 'true');
            if (!wasSelected) {
              var picks = resolveHelmetCardPicks(card);
              var resolvedVariant = findHelmetVariantByOptionValues(product, picks);
              if (resolvedVariant && resolvedVariant.available) {
                state.selectedHelmets[productKey] = buildHelmetSelectionEntry(product, resolvedVariant);
              }
            }
            applyHelmetCardSelection(card);
            refreshAllHelmetCards();
          });
        });
        var input = card.querySelector('input[type="checkbox"][data-helmet-toggle-input]');
        if (input) {
          input.addEventListener('change', function (event) {
            if (input.disabled) {
              if (event) event.preventDefault();
              input.checked = false;
              return;
            }
            toggleHelmetProduct(card);
          });
        }
        card.addEventListener('click', function (event) {
          if (card.classList.contains('is-disabled')) return;
          var target = event && event.target;
          if (target && target.closest) {
            if (target.closest('.krs-bundle-builder__toggle')) return;
            if (target.closest('[data-helmet-swatch]')) return;
            if (target.closest('[data-helmet-learn-more]')) return;
          }
          toggleHelmetProduct(card);
        });
      });
    }

    function getHelmetModalForProduct(productId) {
      if (!productId) return null;
      return document.getElementById('KrsBundleHelmetModal-' + uid + '-' + productId);
    }

    function setHelmetModalActiveDot(modal, activeIndex) {
      if (!modal) return;
      var dots = modal.querySelectorAll('[data-helmet-modal-dot-index]');
      Array.prototype.forEach.call(dots, function (dotButton) {
        var index = Number(dotButton.getAttribute('data-helmet-modal-dot-index') || 0);
        var isActive = index === activeIndex;
        dotButton.classList.toggle('product-media-gallery__dot--active', isActive);
        dotButton.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      var prevButton = modal.querySelector('[data-helmet-modal-prev]');
      var nextButton = modal.querySelector('[data-helmet-modal-next]');
      if (prevButton) prevButton.disabled = activeIndex <= 1;
      if (nextButton) nextButton.disabled = activeIndex >= dots.length;
    }

    function syncHelmetModalActiveDotFromSlider(modal) {
      if (!modal) return;
      var slider = modal.querySelector('[data-helmet-modal-slider]');
      if (!slider) return;
      var slides = slider.querySelectorAll('[data-helmet-modal-slide-index]');
      if (!slides.length) return;
      var sliderRect = slider.getBoundingClientRect();
      var sliderCenter = sliderRect.left + sliderRect.width / 2;
      var closestIndex = 1;
      var smallestDistance = Infinity;
      Array.prototype.forEach.call(slides, function (slide) {
        var slideRect = slide.getBoundingClientRect();
        var slideCenter = slideRect.left + slideRect.width / 2;
        var distance = Math.abs(slideCenter - sliderCenter);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestIndex = Number(slide.getAttribute('data-helmet-modal-slide-index') || 1);
        }
      });
      setHelmetModalActiveDot(modal, closestIndex);
    }

    function scrollHelmetModalSliderTo(modal, index) {
      if (!modal) return;
      var slider = modal.querySelector('[data-helmet-modal-slider]');
      if (!slider) return;
      var slides = slider.querySelectorAll('[data-helmet-modal-slide-index]');
      var slide = slides[Math.max(0, Math.min(slides.length - 1, Number(index || 1) - 1))];
      if (!slide) return;
      var targetLeft = slide.offsetLeft - (slider.clientWidth / 2) + (slide.clientWidth / 2);
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
      setHelmetModalActiveDot(modal, Number(index || 1));
    }

    function setupHelmetModalGallery(modal) {
      if (!modal || modal.__krsHelmetGalleryBound) return;
      modal.__krsHelmetGalleryBound = true;
      var slider = modal.querySelector('[data-helmet-modal-slider]');
      if (!slider) return;

      Array.prototype.forEach.call(modal.querySelectorAll('[data-helmet-modal-dot-index]'), function (dotButton) {
        dotButton.addEventListener('click', function () {
          var index = Number(dotButton.getAttribute('data-helmet-modal-dot-index') || 0);
          if (!index) return;
          scrollHelmetModalSliderTo(modal, index);
        });
      });

      var prevButton = modal.querySelector('[data-helmet-modal-prev]');
      var nextButton = modal.querySelector('[data-helmet-modal-next]');
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          var dots = modal.querySelectorAll('[data-helmet-modal-dot-index]');
          if (!dots.length) return;
          var current = 1;
          Array.prototype.forEach.call(dots, function (dot) {
            if (dot.classList.contains('product-media-gallery__dot--active')) current = Number(dot.getAttribute('data-helmet-modal-dot-index') || 1);
          });
          scrollHelmetModalSliderTo(modal, Math.max(1, current - 1));
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          var dots = modal.querySelectorAll('[data-helmet-modal-dot-index]');
          if (!dots.length) return;
          var current = 1;
          Array.prototype.forEach.call(dots, function (dot) {
            if (dot.classList.contains('product-media-gallery__dot--active')) current = Number(dot.getAttribute('data-helmet-modal-dot-index') || 1);
          });
          scrollHelmetModalSliderTo(modal, Math.min(dots.length, current + 1));
        });
      }

      var scrollRaf = null;
      slider.addEventListener('scroll', function () {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          syncHelmetModalActiveDotFromSlider(modal);
        });
      });
      window.addEventListener('resize', function () {
        syncHelmetModalActiveDotFromSlider(modal);
      });
      syncHelmetModalActiveDotFromSlider(modal);
    }

    function openHelmetModal(modal) {
      if (!modal) return;
      var productId = modal.getAttribute('data-helmet-modal-product-id') || '';
      if (modal.parentNode !== document.body) {
        if (!helmetModalOriginalParents[productId]) {
          helmetModalOriginalParents[productId] = modal.parentNode;
          helmetModalOriginalNextSiblings[productId] = modal.nextSibling;
        }
        document.body.appendChild(modal);
      }
      setupHelmetModalGallery(modal);
      helmetModalReturnFocusEl = document.activeElement && document.activeElement.focus ? document.activeElement : null;
      modal.setAttribute('open', '');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('krs-bundle-builder__modal-open');
      scrollHelmetModalSliderTo(modal, 1);
      var dialog = modal.querySelector('.krs-bundle-builder__modal-dialog');
      if (dialog && dialog.focus) {
        dialog.focus();
        return;
      }
      var closeButton = modal.querySelector('.krs-bundle-builder__modal-close');
      if (closeButton && closeButton.focus) closeButton.focus();
    }

    function closeHelmetModal(modal, restoreFocus) {
      if (!modal || !modal.hasAttribute('open')) return;
      modal.removeAttribute('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('krs-bundle-builder__modal-open');
      if (restoreFocus && helmetModalReturnFocusEl && helmetModalReturnFocusEl.focus) {
        helmetModalReturnFocusEl.focus();
      }
      helmetModalReturnFocusEl = null;
    }

    function closeAllHelmetModals(restoreFocus) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-helmet-modal][open]'), function (modal) {
        closeHelmetModal(modal, restoreFocus);
      });
    }

    function setupHelmetLearnMoreModals() {
      if (!helmetGroupsContainer || helmetGroupsContainer.__krsHelmetModalsBound) return;
      helmetGroupsContainer.__krsHelmetModalsBound = true;

      Array.prototype.forEach.call(helmetGroupsContainer.querySelectorAll('[data-helmet-learn-more]'), function (btn) {
        btn.addEventListener('click', function (event) {
          if (event) event.preventDefault();
          var targetId = btn.getAttribute('data-helmet-modal-target');
          var modal = getHelmetModalForProduct(targetId);
          if (!modal) return;
          openHelmetModal(modal);
        });
      });

      Array.prototype.forEach.call(document.querySelectorAll('[data-helmet-modal]'), function (modal) {
        Array.prototype.forEach.call(modal.querySelectorAll('[data-helmet-modal-close]'), function (closeTarget) {
          closeTarget.addEventListener('click', function () {
            closeHelmetModal(modal, true);
          });
        });
      });

      document.addEventListener('keydown', function (event) {
        if ((event && event.key) !== 'Escape') return;
        var anyOpen = document.querySelector('[data-helmet-modal][open]');
        if (!anyOpen) return;
        event.preventDefault();
        closeAllHelmetModals(true);
      });
    }

    function getTwoStepUpliftCompareAtCents() {
      var uplift = getTwoStepUpliftConfig();
      return Number(uplift.compareAtCents || 0);
    }

    function getTwoStepUpliftDiscountCents() {
      var uplift = getTwoStepUpliftConfig();
      var fromUplift = Number(uplift.discountCents || 0);
      if (fromUplift > 0) return fromUplift;
      if (twoStepUpliftData && twoStepUpliftData.discountCents) {
        return Number(twoStepUpliftData.discountCents || 0);
      }
      return 0;
    }

    function getTwoStepUpliftDisplayPriceCents(baseCents) {
      var base = Number(baseCents || 0);
      var discount = getTwoStepUpliftDiscountCents();
      return Math.max(0, base - discount);
    }

    function getTwoStepChoices() {
      if (!isTwoStepMode) return [];
      var choices = Array.isArray(twoStepConfig.step1Choices) ? twoStepConfig.step1Choices : [];
      return choices.filter(function (choice) {
        return !!(choice && choice.variantId);
      });
    }

    function getTwoStepChoiceByLabel(step1Label) {
      var normalizedTarget = normalizeTwoStepLabel(step1Label);
      var choices = getTwoStepChoices();
      for (var i = 0; i < choices.length; i += 1) {
        var label = choices[i] && choices[i].label ? choices[i].label : '';
        if (normalizeTwoStepLabel(label) === normalizedTarget) return choices[i];
      }
      return null;
    }

    function getTwoStepGroup(mode) {
      var groups = Array.isArray(data && data.groups) ? data.groups : [];
      if (!groups.length) return null;
      if (mode === 'bike-only') {
        for (var i = 0; i < groups.length; i += 1) {
          var baseKey = String((groups[i].key || groups[i].id || '')).toLowerCase();
          if (baseKey === 'base-only') return groups[i];
        }
        return null;
      }
      for (var j = 0; j < groups.length; j += 1) {
        var upliftKey = String((groups[j].key || groups[j].id || '')).toLowerCase();
        if (upliftKey.indexOf('uplift') >= 0) return groups[j];
      }
      for (var k = 0; k < groups.length; k += 1) {
        var nonBaseKey = String((groups[k].key || groups[k].id || '')).toLowerCase();
        if (nonBaseKey !== 'base-only') return groups[k];
      }
      return null;
    }

    function getTwoStepRule(step1Label) {
      if (!isTwoStepMode || !twoStepConfig || !twoStepConfig.step2Rules) return null;
      var rules = twoStepConfig.step2Rules || {};
      if (Object.prototype.hasOwnProperty.call(rules, step1Label)) {
        return rules[step1Label];
      }
      var normalizedTarget = normalizeTwoStepLabel(step1Label);
      var keys = Object.keys(rules);
      for (var i = 0; i < keys.length; i += 1) {
        if (normalizeTwoStepLabel(keys[i]) === normalizedTarget) {
          return rules[keys[i]];
        }
      }
      return null;
    }

    function resolveTwoStepSelection(step1Label, mode) {
      var selectedMode = mode === 'uplift' ? 'uplift' : 'bike-only';
      var rule = getTwoStepRule(step1Label) || {};
      var bikeOnlyVariantId = normalizeVariantId(rule.bikeOnlyVariantId);
      var upliftVariantId = normalizeVariantId(rule.upliftVariantId);
      var bikeOnlyPriceCents = Number(rule.bikeOnlyPriceCents || 0);
      var upliftPriceCents = Number(rule.upliftPriceCents || 0);
      var bikeOnlyCompareAtCents = Number(rule.bikeOnlyCompareAtCents || 0);
      var upliftCompareAtCents = Number(rule.upliftCompareAtCents || 0);
      if (selectedMode === 'uplift' && !upliftVariantId) return null;
      var variantId = selectedMode === 'uplift' ? upliftVariantId : bikeOnlyVariantId;
      var priceCents = selectedMode === 'uplift' ? upliftPriceCents : bikeOnlyPriceCents;
      if (!variantId) return null;
      var matchedSizeOption = findBundleSizeOptionByVariantId(variantId) || findBundleSizeOptionByLabel(step1Label);
      var imageUrl = selectedMode === 'uplift' ? String(rule.upliftImageUrl || '') : String(rule.bikeOnlyImageUrl || '');
      if (!imageUrl && matchedSizeOption && matchedSizeOption.imageUrl) imageUrl = matchedSizeOption.imageUrl;
      return {
        mode: selectedMode,
        variantId: variantId,
        priceCents: priceCents,
        compareAtCents: selectedMode === 'uplift' ? upliftCompareAtCents : bikeOnlyCompareAtCents,
        upliftLabel: String(rule.upliftLabel || ''),
        label: getBundleSizeOptionLabel(matchedSizeOption) || String(step1Label || ''),
        optionValueId: matchedSizeOption && matchedSizeOption.optionValueId ? matchedSizeOption.optionValueId : null,
        mediaId: matchedSizeOption && matchedSizeOption.mediaId ? matchedSizeOption.mediaId : null,
        imageUrl: imageUrl
      };
    }

    function syncTwoStepVisualSelection() {
      Array.prototype.forEach.call(sizeContainer.querySelectorAll('.krs-bundle-builder__size-card[data-step1-label]'), function (card) {
        var label = String(card.getAttribute('data-step1-label') || '');
        var isActive = String(state.selectedSize || '') === label;
        card.classList.toggle('is-active', isActive);
        var btn = card.querySelector('.krs-bundle-builder__size-btn');
        if (btn) btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      [
        ['uplift', 'uplift'],
        ['adventure', 'adventure']
      ].forEach(function (entry) {
        var toggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="' + entry[0] + '"]');
        if (!toggleCard) return;
        var toggleOn = String(state.selectedTwoStepMode || '') === entry[1];
        toggleCard.classList.toggle('is-selected', toggleOn);
        var toggleInput = toggleCard.querySelector('input[type="checkbox"][data-two-step-toggle]');
        if (toggleInput) toggleInput.checked = toggleOn;
      });
    }

    function setTwoStepToggleDisabled(card, disabled) {
      if (!card) return;
      card.classList.toggle('is-disabled', disabled);
      card.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      var toggleInput = card.querySelector('input[type="checkbox"][data-two-step-toggle]');
      if (toggleInput) toggleInput.disabled = disabled;
    }

    function updateTwoStepModeAvailability() {
      if (!isTwoStepMode) return;
      var upliftToggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="uplift"]');
      var adventureToggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="adventure"]');
      if (!upliftToggleCard && !adventureToggleCard) return;
      var upliftAddon = getUpliftAddonConfig();
      var adventure = getAdventureConfig();
      setTwoStepToggleDisabled(upliftToggleCard, !state.selectedSize || !(upliftAddon && upliftAddon.available));
      setTwoStepToggleDisabled(adventureToggleCard, !state.selectedSize || !adventure.available);
    }

    function updateTwoStepModeCards() {
      if (!isTwoStepMode) return;
      var upliftCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="uplift"]');
      var upliftAddon = getUpliftAddonConfig();
      var upliftConfig = getTwoStepUpliftConfig();

      function updateUpliftCard(card) {
        if (!card) return;
        var titleNode = card.querySelector('[data-role="group-product-title"]') || card.querySelector('.krs-bundle-builder__group-title');
        var descNode = card.querySelector('.krs-bundle-builder__group-sub');
        var currentDollars = card.querySelector('[data-role="group-current-dollars"]');
        var currentCents = card.querySelector('[data-role="group-current-cents"]');
        var compareNode = card.querySelector('[data-role="group-compare-price"]');
        var savingsBadge = card.querySelector('[data-role="group-savings-badge"]');
        var thumbImg = card.querySelector('.krs-bundle-builder__group-thumb img');

        var cardImage = String(upliftConfig.imageUrl || (upliftAddon && upliftAddon.imageUrl) || '');
        var cardTitle = String(upliftConfig.cardTitle || (upliftAddon && upliftAddon.title) || upliftConfig.productTitle || tStr('upliftProductFallback', 'Uplift Backpack'));
        if (thumbImg && cardImage) {
          var sep = cardImage.indexOf('?') >= 0 ? '&' : '?';
          thumbImg.src = cardImage + sep + 'width=140';
          thumbImg.alt = cardTitle;
        }
        if (titleNode) titleNode.textContent = cardTitle;
        var toggleLabel = card.querySelector('.krs-bundle-builder__toggle');
        if (toggleLabel) toggleLabel.setAttribute('aria-label', tStr('toggleItem', 'Toggle {{ name }}', { name: cardTitle }));

        if (!upliftAddon || !upliftAddon.available) {
          if (descNode) {
            descNode.textContent = String(upliftConfig.description || tStr('upliftDefaultDescription', 'Switch to the uplift variant for this bike.'));
          }
          if (currentDollars) currentDollars.textContent = '—';
          if (currentCents) currentCents.textContent = '';
          if (compareNode) compareNode.style.display = 'none';
          if (savingsBadge) {
            savingsBadge.textContent = '';
            savingsBadge.style.display = 'none';
          }
          return;
        }

        var displayPriceCents = getTwoStepUpliftDisplayPriceCents(upliftAddon.priceCents);
        var priceParts = formatMoneyParts(displayPriceCents);
        if (currentDollars) currentDollars.textContent = priceParts.dollars;
        if (currentCents) currentCents.textContent = priceParts.cents;
        if (compareNode) {
          compareNode.hidden = true;
          compareNode.style.display = 'none';
        }

        var compareAt = Math.max(0, Number(upliftAddon.priceCents || 0));
        var savings = Math.max(0, Number(compareAt || 0) - Number(displayPriceCents || 0));
        if (savingsBadge) {
          if (savings > 0) {
            savingsBadge.textContent = tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savings) });
            savingsBadge.style.display = 'inline-flex';
          } else {
            savingsBadge.textContent = '';
            savingsBadge.style.display = 'none';
          }
        }

        if (descNode) {
          var upliftDesc = String(upliftConfig.description || '').trim();
          var upliftLabel = String((upliftAddon && upliftAddon.title) || upliftConfig.productTitle || '').trim();
          descNode.textContent = upliftDesc || upliftLabel || tStr('upliftDefaultDescription', 'Switch to the uplift variant for this bike.');
        }
      }

      function updateAdventureCard(card) {
        if (!card) return;
        var adventure = getAdventureConfig();
        var titleNode = card.querySelector('[data-role="group-product-title"]') || card.querySelector('.krs-bundle-builder__group-title');
        var descNode = card.querySelector('.krs-bundle-builder__group-sub');
        var currentDollars = card.querySelector('[data-role="group-current-dollars"]');
        var currentCents = card.querySelector('[data-role="group-current-cents"]');
        var compareNode = card.querySelector('[data-role="group-compare-price"]');
        var savingsBadge = card.querySelector('[data-role="group-savings-badge"]');
        var thumbImg = card.querySelector('.krs-bundle-builder__group-thumb img');
        var display = getAdventureDisplayCents(adventure);

        if (titleNode && adventure.title) titleNode.textContent = adventure.title;
        if (descNode && adventure.subtitle) descNode.textContent = adventure.subtitle;
        var toggleLabel = card.querySelector('.krs-bundle-builder__toggle');
        if (toggleLabel) toggleLabel.setAttribute('aria-label', tStr('toggleItem', 'Toggle {{ name }}', { name: adventure.title }));
        if (thumbImg && adventure.imageUrl) {
          var sep = adventure.imageUrl.indexOf('?') >= 0 ? '&' : '?';
          thumbImg.src = adventure.imageUrl + sep + 'width=140';
          thumbImg.alt = adventure.title;
        }

        var priceParts = formatMoneyParts(display.current);
        if (currentDollars) currentDollars.textContent = priceParts.dollars;
        if (currentCents) currentCents.textContent = priceParts.cents;
        if (compareNode) {
          compareNode.hidden = true;
          compareNode.style.display = 'none';
        }
        if (savingsBadge) {
          if (display.savings > 0) {
            savingsBadge.textContent = tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(display.savings) });
            savingsBadge.style.display = 'inline-flex';
          } else {
            savingsBadge.textContent = '';
            savingsBadge.style.display = 'none';
          }
        }
      }

      updateUpliftCard(upliftCard);
      updateAdventureCard(groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="adventure"]'));
    }

    function withShopifyWidth(url, width) {
      var value = String(url || '');
      if (!value) return '';
      var sep = value.indexOf('?') >= 0 ? '&' : '?';
      return value + sep + 'width=' + width;
    }

    function syncAdventureGallery() {
      var sectionHost = root.closest('[data-section]');
      if (!sectionHost || !sectionHost.dataset || !sectionHost.dataset.section) return;
      var sectionId = String(sectionHost.dataset.section);
      var mediaGallery = document.getElementById('MediaGallery-' + sectionId);
      if (!mediaGallery) return;
      var slider = document.getElementById('Slider-Gallery-' + sectionId) || mediaGallery.querySelector('.product__media-list');
      if (!slider) return;
      var thumbList = document.getElementById('Slider-Thumbnails-' + sectionId);
      var existing = slider.querySelector('[data-krs-bundle-slide]');
      var existingThumb = thumbList ? thumbList.querySelector('[data-krs-bundle-thumb]') : null;
      var mode = String(state.selectedTwoStepMode || '');
      var bundleImage = null;
      if (mode === 'adventure') {
        var adventure = getAdventureConfig();
        if (adventure.available && adventure.imageUrl) {
          bundleImage = { url: adventure.imageUrl, alt: adventure.title || 'All Day Adventure Bundle' };
        }
      } else if (mode === 'uplift') {
        var upliftConfig = getTwoStepUpliftConfig();
        var upliftAddon = getUpliftAddonConfig();
        var upliftImageUrl = String((upliftConfig && upliftConfig.imageUrl) || (upliftAddon && upliftAddon.imageUrl) || '');
        if (upliftAddon && upliftAddon.available && upliftImageUrl) {
          bundleImage = {
            url: upliftImageUrl,
            alt: String((upliftConfig && upliftConfig.cardTitle) || (upliftAddon && upliftAddon.title) || 'Uplift Dirt Hero Bundle')
          };
        }
      }

      function activateMedia(mediaId) {
        if (!mediaId || typeof mediaGallery.setActiveMedia !== 'function') return false;
        if (!mediaGallery.querySelector('[data-media-id="' + mediaId + '"]')) return false;
        var previousScrollY = window.scrollY || window.pageYOffset || 0;
        mediaGallery.dataset.skipScrollOnce = 'true';
        mediaGallery.setActiveMedia(mediaId, false);
        var activeSlide = mediaGallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (activeSlide && activeSlide.parentElement && typeof activeSlide.parentElement.scrollTo === 'function') {
          activeSlide.parentElement.scrollTo({ left: activeSlide.offsetLeft || 0, behavior: 'auto' });
        }
        requestAnimationFrame(function () {
          var currentScrollY = window.scrollY || window.pageYOffset || 0;
          if (Math.abs(currentScrollY - previousScrollY) > 1) {
            window.scrollTo(window.scrollX || 0, previousScrollY);
          }
        });
        return true;
      }

      if (!bundleImage) {
        if (!existing && !existingThumb) return;
        var restoreMediaId = existing ? String(existing.getAttribute('data-krs-restore-media-id') || '') : '';
        if (existing) existing.remove();
        if (existingThumb) existingThumb.remove();
        var selectedOption = findBundleSizeOptionByLabel(state.selectedSize);
        if (selectedOption && syncSelectedVariantMedia(selectedOption)) return;
        if (restoreMediaId) activateMedia(restoreMediaId);
        return;
      }

      var wideUrl = withShopifyWidth(bundleImage.url, 1445);
      var thumbUrl = withShopifyWidth(bundleImage.url, 200);
      var mediaId = sectionId + '-krs-bundle-image';
      var restoreId = existing ? String(existing.getAttribute('data-krs-restore-media-id') || '') : '';
      if (existing) existing.remove();
      if (existingThumb) existingThumb.remove();
      if (!restoreId) {
        var activeItem = slider.querySelector('.product__media-item.is-active') || slider.querySelector('.product__media-item');
        if (activeItem) restoreId = String(activeItem.getAttribute('data-media-id') || '');
      }

      var template = null;
      var mediaItems = slider.querySelectorAll('.product__media-item');
      for (var mediaIndex = 0; mediaIndex < mediaItems.length; mediaIndex += 1) {
        if (mediaItems[mediaIndex].getAttribute('data-media-type') === 'image') {
          template = mediaItems[mediaIndex];
          break;
        }
      }
      var containerClass = 'product-media-container media-type-image media-fit-contain global-media-settings gradient';
      if (template) {
        var sourceContainer = template.querySelector('.product-media-container');
        if (sourceContainer && sourceContainer.className) containerClass = sourceContainer.className;
      }

      var alt = escapeHtml(bundleImage.alt || 'Bundle');
      var slide = document.createElement('li');
      slide.className = 'product__media-item grid__item slider__slide';
      slide.setAttribute('data-media-id', mediaId);
      slide.setAttribute('data-media-type', 'image');
      slide.setAttribute('data-krs-bundle-slide', 'true');
      if (restoreId) slide.setAttribute('data-krs-restore-media-id', restoreId);
      slide.innerHTML =
        '<div class="' + containerClass + '" style="--ratio: 1; --preview-ratio: 1;">' +
          '<div class="product__media media media--transparent">' +
            '<img src="' + escapeHtml(wideUrl) + '" alt="' + alt + '" loading="eager">' +
          '</div>' +
        '</div>';
      var galleryImage = slide.querySelector('img');
      if (galleryImage) {
        galleryImage.addEventListener('load', function () {
          if (!galleryImage.naturalWidth || !galleryImage.naturalHeight) return;
          var ratio = String(galleryImage.naturalWidth / galleryImage.naturalHeight);
          var container = slide.querySelector('.product-media-container');
          if (!container) return;
          container.style.setProperty('--ratio', ratio);
          container.style.setProperty('--preview-ratio', ratio);
        });
      }
      slider.insertBefore(slide, slider.firstChild);

      if (thumbList) {
        var thumb = document.createElement('li');
        thumb.className = 'thumbnail-list__item slider__slide';
        thumb.setAttribute('data-target', mediaId);
        thumb.setAttribute('data-krs-bundle-thumb', 'true');
        thumb.setAttribute('data-media-position', '1');
        thumb.innerHTML =
          '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="' + alt + '">' +
            '<img src="' + escapeHtml(thumbUrl) + '" alt="' + alt + '" loading="eager">' +
          '</button>';
        thumbList.insertBefore(thumb, thumbList.firstChild);
        var thumbButton = thumb.querySelector('button');
        if (thumbButton) {
          thumbButton.addEventListener('click', function () {
            activateMedia(mediaId);
          });
        }
      }

      activateMedia(mediaId);
    }

    function applyTwoStepSelection(step1Label, mode) {
      var resolvedBike = resolveTwoStepSelection(step1Label, 'bike-only');
      if (!resolvedBike) return;
      var previousVariantId = normalizeVariantId(state.selectedVariantId);
      var nextVariantId = normalizeVariantId(resolvedBike.variantId);
      state.selectedSize = String(step1Label || '');
      if (mode === 'adventure' && !getAdventureConfig().available) mode = 'bike-only';
      state.selectedTwoStepMode = mode === 'uplift' || mode === 'adventure' ? mode : 'bike-only';
      writeUpliftAddonToUrl();
      updateSizeDisclaimer(state.selectedSize);
      // Two-step mode keeps the base bike variant as the canonical product variant.
      // Uplift mode only toggles whether the uplift addon line item is included.
      state.selectedVariantId = resolvedBike.variantId;
      state.selectedVariantPriceCents = Number(resolvedBike.priceCents || 0);
      state.selectedVariantCompareAtCents = Number(resolvedBike.compareAtCents || 0);
      // Only re-sync the native picker (which can trigger a section swap) when
      // the underlying bike variant actually changed. A pure Uplift toggle should
      // not move the viewport.
      if (nextVariantId !== previousVariantId) {
        syncBundleSelectionWithNativeFlow(resolvedBike, step1Label);
      }
      state.selectedGroupId = null;
      state.selectedAddons = {};
      state.pendingAddonSelections = {};
      syncTwoStepVisualSelection();
      updateTwoStepModeAvailability();
      updateTwoStepModeCards();
      updateStep2Visibility();
      updateStep3Visibility();
      updateHelmetAvailability();
      syncHelmetVisualSelection();
      formatSummary();
      writeStep1ToUrl(resolvedBike);
      writeUpliftAddonToUrl();
      syncAdventureGallery();
    }

    function renderTwoStepFlow() {
      if (!isTwoStepMode) return false;
      var choices = getTwoStepChoices();
      if (!choices.length) return false;

      var step2Title = step2Container ? step2Container.querySelector('.krs-bundle-builder__title') : null;
      if (step2Title) step2Title.textContent = getTwoStepUpliftTitle();

      var allowedByLabel = {};
      choices.forEach(function (choice) {
        if (!choice || !choice.label) return;
        allowedByLabel[normalizeTwoStepLabel(choice.label)] = choice;
      });
      Array.prototype.forEach.call(sizeContainer.querySelectorAll('.krs-bundle-builder__size-card'), function (card) {
        var btn = card.querySelector('.krs-bundle-builder__size-btn');
        if (!btn) return;
        var label = String(btn.getAttribute('data-size-label') || btn.textContent || '').trim();
        var key = normalizeTwoStepLabel(label);
        var choice = allowedByLabel[key];
        if (!choice) {
          card.style.display = 'none';
          return;
        }
        card.style.display = '';
        card.setAttribute('data-step1-label', String(choice.label || label));
        btn.setAttribute('data-size-label', String(choice.label || label));
        if (choice.variantId) btn.setAttribute('data-variant-id', String(choice.variantId));
        if (choice.priceCents != null) btn.setAttribute('data-price-cents', String(choice.priceCents));
        btn.disabled = !choice.available || !choice.variantId;
        if (!btn.__krsTwoStepBound) {
          btn.__krsTwoStepBound = true;
          btn.addEventListener('click', function () {
            var currentMode = String(state.selectedTwoStepMode || '');
            var nextMode = currentMode === 'uplift' || currentMode === 'adventure' ? currentMode : 'bike-only';
            applyTwoStepSelection(String(choice.label || label), nextMode);
          });
        }
      });

      groupsContainer.classList.remove('is-locked');
      var toggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="uplift"]');
      var adventureCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="adventure"]');
      if (!toggleCard && !adventureCard) {
        if (step2Container) {
          step2Container.classList.remove('is-visible');
          step2Container.style.display = 'none';
        }
      } else if (step2Container && step2Container.style.display === 'none') {
        step2Container.style.display = '';
      }

      var toggleInput = toggleCard ? toggleCard.querySelector('input[type="checkbox"][data-two-step-toggle]') : null;
      if (toggleInput && !toggleInput.__krsTwoStepBound) {
        toggleInput.__krsTwoStepBound = true;
        toggleInput.addEventListener('change', function (event) {
          if (!state.selectedSize) {
            toggleInput.checked = false;
            return;
          }
          var checked = !!(event && event.target && event.target.checked);
          applyTwoStepSelection(state.selectedSize, checked ? 'uplift' : 'bike-only');
        });
      }
      if (toggleCard && !toggleCard.__krsTwoStepBound) {
        toggleCard.__krsTwoStepBound = true;
        toggleCard.addEventListener('click', function (event) {
          if (!state.selectedSize) return;
          var target = event && event.target;
          if (target && target.closest && target.closest('.krs-bundle-builder__toggle')) return;
          var disabled = toggleInput && toggleInput.disabled;
          if (disabled) return;
          var nextMode = String(state.selectedTwoStepMode || '') === 'uplift' ? 'bike-only' : 'uplift';
          applyTwoStepSelection(state.selectedSize, nextMode);
        });
      }

      var adventureInput = adventureCard ? adventureCard.querySelector('input[type="checkbox"][data-two-step-toggle]') : null;
      if (adventureInput && !adventureInput.__krsTwoStepBound) {
        adventureInput.__krsTwoStepBound = true;
        adventureInput.addEventListener('change', function (event) {
          if (!state.selectedSize) {
            adventureInput.checked = false;
            return;
          }
          var checked = !!(event && event.target && event.target.checked);
          applyTwoStepSelection(state.selectedSize, checked ? 'adventure' : 'bike-only');
        });
      }
      if (adventureCard && !adventureCard.__krsTwoStepBound) {
        adventureCard.__krsTwoStepBound = true;
        adventureCard.addEventListener('click', function (event) {
          if (!state.selectedSize) return;
          var target = event && event.target;
          if (target && target.closest && target.closest('.krs-bundle-builder__toggle')) return;
          if (adventureInput && adventureInput.disabled) return;
          var nextMode = String(state.selectedTwoStepMode || '') === 'adventure' ? 'bike-only' : 'adventure';
          applyTwoStepSelection(state.selectedSize, nextMode);
        });
      }

      var urlState = readUrlState();
      var sizeOptionIndexForUrl = Number(data && data.sizeOptionIndex);
      if (isNaN(sizeOptionIndexForUrl)) sizeOptionIndexForUrl = 0;
      var targetOptionValueId = urlState.optionValues[sizeOptionIndexForUrl] ? String(urlState.optionValues[sizeOptionIndexForUrl]) : '';
      var targetVariantId = urlState.variantId ? String(urlState.variantId) : '';
      var initialStep1Label = String(state.selectedSize || '');

      if (!initialStep1Label && targetOptionValueId) {
        var matchedByOptionValue = findBundleSizeOptionByOptionValueId(targetOptionValueId);
        var matchedVariantId = matchedByOptionValue ? normalizeVariantId(matchedByOptionValue.variantId) : null;
        if (matchedVariantId) {
          for (var optIdx = 0; optIdx < choices.length; optIdx += 1) {
            var optChoice = choices[optIdx];
            if (optChoice && normalizeVariantId(optChoice.variantId) === matchedVariantId) {
              initialStep1Label = String(optChoice.label || '');
              break;
            }
          }
        }
      }

      if (!initialStep1Label && targetVariantId) {
        for (var varIdx = 0; varIdx < choices.length; varIdx += 1) {
          var varChoice = choices[varIdx];
          if (varChoice && normalizeVariantId(varChoice.variantId) === targetVariantId) {
            initialStep1Label = String(varChoice.label || '');
            break;
          }
        }
      }

      if (!initialStep1Label) {
        for (var choiceIdx = 0; choiceIdx < choices.length; choiceIdx += 1) {
          var candidateChoice = choices[choiceIdx];
          if (candidateChoice && candidateChoice.available && candidateChoice.variantId) {
            initialStep1Label = String(candidateChoice.label || '');
            break;
          }
        }
      }
      if (initialStep1Label) {
        var initialMode = 'bike-only';
        if (urlState.addonIntent === 'adventure') initialMode = 'adventure';
        else if (urlState.addonIntent === 'uplift') initialMode = 'uplift';
        applyTwoStepSelection(initialStep1Label, initialMode);
      }

      setAddButtonDisabled(true);
      updateTwoStepModeAvailability();
      updateTwoStepModeCards();
      updateStep2Visibility();
      updateStep3Visibility();
      formatSummary();
      return true;
    }

    function formatSummary() {
      if (isTwoStepMode) {
        if (summaryEl) {
          summaryEl.classList.toggle('has-size-selected', !!state.selectedVariantId);
        }
        if (!state.selectedSize || !state.selectedVariantId) {
          summaryMain.textContent = tStr('selectBikeToStart', 'Select a bike to start');
          summaryItems.innerHTML = '';
          summaryItems.style.display = 'none';
          summaryTotal.textContent = '—';
          summarySave.textContent = '';
          summarySave.style.display = 'none';
          if (summaryAddons) {
            summaryAddons.innerHTML = '';
            summaryAddons.style.display = 'none';
          }
          setAddButtonDisabled(true);
          syncStickySummary();
          handleStickySummaryVisibility();
          return;
        }
        var step1Label = String(state.selectedSize || 'Bike');
        var upliftSelected = state.selectedTwoStepMode === 'uplift' || state.selectedTwoStepMode === 'adventure';
        var adventureSelected = state.selectedTwoStepMode === 'adventure';
        var upliftAddon = upliftSelected ? getUpliftAddonConfig() : null;
        var adventure = adventureSelected ? getAdventureConfig() : null;
        var adventureDisplay = adventureSelected ? getAdventureDisplayCents(adventure) : null;
        summaryMain.textContent = resolveBikeOnlyTitle(step1Label);
        var step1Rule = getTwoStepRule(step1Label) || {};
        var step1PriceCents = Number(step1Rule.bikeOnlyPriceCents || state.selectedVariantPriceCents || 0);
        var finalPriceCents = Number(state.selectedVariantPriceCents || 0);
        var DIRT_HERO_WHEEL_KIT_CENTS = 14000;
        var summaryLines = [];
        var step1Parts = step1Label.split('+').map(function (part) { return String(part || '').trim(); }).filter(Boolean);

        if (step1Parts.length > 1) {
          var baseBikeLabel = step1Parts[0];
          var baseBikeChoice = getTwoStepChoiceByLabel(baseBikeLabel);
          var baseBikePrice = Number(baseBikeChoice && baseBikeChoice.priceCents ? baseBikeChoice.priceCents : 0);
          var extraParts = step1Parts.slice(1);
          var fixedExtraTotal = 0;
          extraParts.forEach(function (part) {
            var partNorm = String(part || '').toLowerCase();
            if (partNorm.indexOf('wheel kit') >= 0) fixedExtraTotal += DIRT_HERO_WHEEL_KIT_CENTS;
          });

          if (!baseBikePrice || baseBikePrice > step1PriceCents) {
            baseBikePrice = Math.max(0, step1PriceCents - fixedExtraTotal);
          }
          var remainingStep1 = Math.max(0, step1PriceCents - baseBikePrice);
          var partRemainder = remainingStep1;
          var perPart = extraParts.length ? Math.floor(remainingStep1 / extraParts.length) : 0;
          extraParts.forEach(function (part, index) {
            var partNorm = String(part || '').toLowerCase();
            var partPrice = 0;
            if (partNorm.indexOf('wheel kit') >= 0) {
              partPrice = DIRT_HERO_WHEEL_KIT_CENTS;
            } else {
              partPrice = index === extraParts.length - 1 ? partRemainder : perPart;
            }
            partRemainder = Math.max(0, partRemainder - partPrice);
            summaryLines.push({ name: part, priceCents: partPrice });
          });
        }

        var upliftDisplayPriceCents = 0;
        var ropeDisplayPriceCents = 0;
        if (upliftSelected && upliftAddon && upliftAddon.available) {
          upliftDisplayPriceCents = adventureDisplay ? adventureDisplay.bagPay : getTwoStepUpliftDisplayPriceCents(upliftAddon.priceCents);
          summaryLines.push({
            name: String(upliftAddon.title || step1Rule.upliftLabel || tStr('upliftProductFallback', 'Uplift Backpack')).trim(),
            priceCents: upliftDisplayPriceCents
          });
        }
        if (adventureSelected && adventure && adventure.available && adventureDisplay) {
          ropeDisplayPriceCents = adventureDisplay.ropePay;
          summaryLines.push({
            name: String(adventure.towRopeTitle || 'Tow Rope').trim(),
            priceCents: ropeDisplayPriceCents
          });
        }

        var helmetEntries = Object.keys(state.selectedHelmets || {}).map(function (k) { return state.selectedHelmets[k]; });
        var helmetTotalCents = 0;
        helmetEntries.forEach(function (h) {
          if (!h || !h.variantId) return;
          var helmetPriceCents = Number(h.priceCents || 0);
          helmetTotalCents += helmetPriceCents;
          var helmetName = String(h.title || 'Helmet');
          if (h.optionValue) helmetName += ' – ' + String(h.optionValue);
          summaryLines.push({ name: helmetName, priceCents: helmetPriceCents });
        });

        var summaryItemsHtml = summaryLines.map(function (line) {
          return '<div class="krs-bundle-builder__summary-item">' +
            '<span class="krs-bundle-builder__summary-item-name">1 x ' + escapeHtml(String(line.name || 'Item')) + '</span>' +
          '</div>';
        }).join('');
        summaryItems.innerHTML = summaryItemsHtml;
        summaryItems.style.display = summaryLines.length ? '' : 'none';
        if (summaryAddons) {
          summaryAddons.innerHTML = '';
          summaryAddons.style.display = 'none';
        }
        var totalWithUpliftCents = finalPriceCents + upliftDisplayPriceCents + ropeDisplayPriceCents + helmetTotalCents;
        var totalParts = formatMoneyParts(totalWithUpliftCents);
        summaryTotal.innerHTML = '<span class="price__dollars">' + escapeHtml(totalParts.dollars) + '</span><span class="price__cents">' + escapeHtml(totalParts.cents) + '</span>';
        var savingsFromCompare = Math.max(0, Number(state.selectedVariantCompareAtCents || 0) - Number(state.selectedVariantPriceCents || 0));
        var savingsFromUpliftCard = 0;
        if (adventureSelected && adventure && adventure.available && adventureDisplay) {
          savingsFromUpliftCard = adventureDisplay.savings;
        } else if (state.selectedTwoStepMode === 'uplift' && upliftAddon && upliftAddon.available) {
          savingsFromUpliftCard = getTwoStepUpliftDiscountCents();
        }
        var savingsFromHelmetCards = 0;
        helmetEntries.forEach(function (h) {
          if (!h || !h.variantId) return;
          var rawCents = Number(h.rawPriceCents || 0);
          var dispCents = Number(h.priceCents || 0);
          if (rawCents > dispCents) savingsFromHelmetCards += (rawCents - dispCents);
          var compareCents = Number(h.compareAtCents || 0);
          if (compareCents > dispCents) savingsFromHelmetCards += Math.max(0, compareCents - Math.max(dispCents, rawCents));
        });
        var savingsFromBadge = 0;
        var savingsGroup = getTwoStepGroup('bike-only');
        if (savingsGroup && savingsGroup.badge) {
          savingsFromBadge = parseBadgeSavingsCents(savingsGroup.badge);
        }
        var savingsCents = savingsFromCompare + savingsFromUpliftCard + savingsFromHelmetCards;
        if (savingsFromBadge > savingsCents) savingsCents = savingsFromBadge;
        summarySave.textContent = savingsCents > 0 ? tStr('youSave', 'You save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savingsCents) }) : '';
        summarySave.style.display = savingsCents > 0 ? '' : 'none';
        setAddButtonDisabled(!state.selectedVariantId);
        syncStickySummary();
        handleStickySummaryVisibility();
        return;
      }

      if (summaryEl) {
        summaryEl.classList.toggle('has-size-selected', !!state.selectedVariantId);
      }
      var baseTitle = String((data && data.baseProductTitle) || 'Base product');
      var baseOnlyTitle = String((data && data.baseOnlyTitle) || 'Bike only');

      var selectedGroup = null;
      for (var i = 0; i < groupsData.length; i += 1) {
        if (groupsData[i].id === state.selectedGroupId) {
          selectedGroup = groupsData[i];
          break;
        }
      }

      if (!state.selectedSize || !state.selectedVariantId) {
        summaryMain.textContent = tStr('selectSizeToStart', 'Select a size to start');
        summaryMain.style.display = '';
        summaryItems.innerHTML = '';
        summaryItems.style.display = 'none';
      } else {
        var setupTitle = selectedGroup && selectedGroup.id !== 'base-only' ? selectedGroup.title : baseOnlyTitle;
        setupTitle = normalizePackageTitle(setupTitle);
        summaryMain.textContent = setupTitle;
        summaryMain.style.display = '';

        var kitItems = [];
        kitItems.push({ name: state.selectedSize || baseTitle, priceCents: state.selectedVariantPriceCents });
        if (selectedGroup && selectedGroup.products) {
          (selectedGroup.products || []).forEach(function (p) {
            kitItems.push({ name: p.shortTitle || p.title || 'Item', priceCents: Number(p.priceCents || 0) });
          });
        }
        var kitItemsHtml = kitItems.map(function (it) {
          return '<div class="krs-bundle-builder__summary-item">' +
            '<span class="krs-bundle-builder__summary-item-name">1 x ' + escapeHtml(it.name) + '</span>' +
            '</div>';
        }).join('');
        summaryItems.innerHTML = kitItemsHtml;
        summaryItems.style.display = kitItems.length ? '' : 'none';

        var selectedAddonKeys = Object.keys(state.selectedAddons || {});
        var addonsData = selectedAddonKeys.length ? loadAddonData() : [];
        var addonItems = [];
        selectedAddonKeys.forEach(function (addonKey) {
          var sel = state.selectedAddons[addonKey];
          if (!sel || !sel.variantId) return;
          var addonConfig = addonsData.find(function (a) { return a && a.key === addonKey; });
          var displayName = (addonConfig && (addonConfig.title || addonConfig.productTitle)) || addonKey;
          if (sel.optionValue) displayName = sel.optionValue + ' - ' + displayName;
          addonItems.push({ name: displayName, priceCents: Number(sel.priceCents || 0) });
        });
        if (summaryAddons) {
          if (addonItems.length > 0) {
            var addonsLabelHtml = '<div class="krs-bundle-builder__summary-addons-label">Add-ons</div>';
            var addonsListHtml = addonItems.map(function (it) {
              return '<div class="krs-bundle-builder__summary-item">' +
                '<span class="krs-bundle-builder__summary-item-name">1 x ' + escapeHtml(it.name) + '</span>' +
                '</div>';
            }).join('');
            summaryAddons.innerHTML = addonsLabelHtml + addonsListHtml;
            summaryAddons.style.display = '';
          } else {
            summaryAddons.innerHTML = '';
            summaryAddons.style.display = 'none';
          }
        }
      }

      var selectedProducts = [];
      var totalCompareCents = 0;
      var badgeSavingsCents = 0;
      if (selectedGroup) {
        (selectedGroup.products || []).forEach(function (p) {
          selectedProducts.push(p);
          totalCompareCents += Number(p.compareAtCents || 0);
        });
        if (selectedGroup.badge) badgeSavingsCents += parseBadgeSavingsCents(selectedGroup.badge);
      }

      var selectedProductsTotal = selectedProducts.reduce(function (sum, p) {
        return sum + Number(p.priceCents || 0);
      }, 0);
      var addonsTotal = 0;
      Object.keys(state.selectedAddons || {}).forEach(function (k) {
        var s = state.selectedAddons[k];
        if (s && s.variantId) addonsTotal += Number(s.priceCents || 0);
      });
      var basePriceForSummary = Number(state.selectedVariantPriceCents || 0);
      var totalCents = basePriceForSummary + selectedProductsTotal + addonsTotal;
      var compareSavingsCents = Math.max(0, totalCompareCents - selectedProductsTotal);
      var savingsCents = Math.max(compareSavingsCents, badgeSavingsCents);

      if (state.selectedVariantId) {
        var totalParts = formatMoneyParts(totalCents);
        summaryTotal.innerHTML = '<span class="price__dollars">' + escapeHtml(totalParts.dollars) + '</span><span class="price__cents">' + escapeHtml(totalParts.cents) + '</span>';
      } else {
        summaryTotal.textContent = '—';
      }
      summarySave.textContent = savingsCents > 0 ? tStr('youSave', 'You save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savingsCents) }) : '';
      summarySave.style.display = savingsCents > 0 ? '' : 'none';

      var activeAddonKeys = Object.keys(state.selectedAddons || {});
      var addonsData = activeAddonKeys.length ? loadAddonData() : [];
      var jerseyValid = true;
      activeAddonKeys.forEach(function (k) {
        var addonConfig = addonsData.find(function (a) { return a && a.key === k; });
        if (addonConfig && addonConfig.hasVariantPicker && state.selectedAddons[k] && !state.selectedAddons[k].variantId) {
          jerseyValid = false;
        }
      });
      setAddButtonDisabled(!state.selectedVariantId || !jerseyValid);
      syncStickySummary();
      handleStickySummaryVisibility();
    }

    function updateStep2Visibility() {
      if (isTwoStepMode) {
        var upliftToggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="uplift"]');
        var adventureToggleCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-two-step-toggle="adventure"]');
        if (!upliftToggleCard && !adventureToggleCard) {
          if (step2Container) {
            step2Container.classList.remove('is-visible');
            step2Container.style.display = 'none';
          }
          if (step2Gate) step2Gate.classList.add('is-hidden');
          groupsContainer.classList.remove('is-locked');
          return;
        }
        if (step2Container && step2Container.style.display === 'none') step2Container.style.display = '';
      }
      var unlocked = isTwoStepMode ? !!state.selectedSize : !!state.selectedVariantId;
      if (step2Container) step2Container.classList.toggle('is-visible', unlocked);
      groupsContainer.classList.toggle('is-locked', !unlocked);
      if (step2Gate) step2Gate.classList.toggle('is-hidden', unlocked);
    }

    function scrollToStep1IfMobile() {
      var step1El = sizeContainer && sizeContainer.closest('.krs-bundle-builder__step');
      if (window.innerWidth > 749 || !step1El) return;
      step1El.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function getSelectedGroup() {
      for (var i = 0; i < groupsData.length; i += 1) {
        if (String(groupsData[i].id) === String(state.selectedGroupId) || String(groupsData[i].key) === String(state.selectedGroupId)) {
          return groupsData[i];
        }
      }
      return null;
    }

    function updateStep3Visibility() {
      if (isTwoStepMode) {
        if (step3Container) {
          step3Container.classList.remove('is-visible');
          step3Container.style.display = 'none';
        }
        if (step3Gate) step3Gate.classList.remove('is-hidden');
        if (addonsContainer) {
          addonsContainer.classList.remove('is-locked');
          addonsContainer.innerHTML = '';
        }
        if (addonsSliderComponent) addonsSliderComponent.classList.remove('is-locked');
        if (addonsButtonsContainer) addonsButtonsContainer.setAttribute('hidden', '');
        return;
      }

      var unlocked = !!state.selectedVariantId && !!state.selectedGroupId;
      if (!unlocked) {
        if (step3Container) step3Container.classList.remove('is-visible');
        if (step3Gate) step3Gate.classList.remove('is-hidden');
      }
      if (addonsContainer) addonsContainer.classList.toggle('is-locked', !unlocked);
      if (addonsSliderComponent) addonsSliderComponent.classList.toggle('is-locked', !unlocked);
      if (!unlocked && addonsButtonsContainer) addonsButtonsContainer.setAttribute('hidden', '');
      if (!unlocked || !addonsContainer) return;

      function applyStep3AddonVisibility(visibleAddonCount) {
        var hasVisibleAddons = visibleAddonCount > 0;
        if (step3Container) step3Container.classList.toggle('is-visible', hasVisibleAddons);
        if (step3Gate) step3Gate.classList.toggle('is-hidden', hasVisibleAddons);
      }

      if (!state.addonsHydrated) {
        state.addonsHydrated = true;
        var renderInitialAddons = function () {
          perf.mark('addons-render-start');
          var visibleCount = renderAddons();
          perf.mark('addons-render-end');
          perf.measure('addons-render', 'addons-render-start', 'addons-render-end');
          applyStep3AddonVisibility(visibleCount);
        };
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(renderInitialAddons);
        } else {
          setTimeout(renderInitialAddons, 0);
        }
        return;
      }
      applyStep3AddonVisibility(renderAddons());
    }

    function isAddonVisible(addon) {
      if (!addon) return false;
      var vis = addon.visibility || {};
      if (vis.sizeIn && Array.isArray(vis.sizeIn) && vis.sizeIn.length) {
        var sizeNorm = String(state.selectedSize || '').replace(/\s+/g, ' ').replace(/[""]/g, '').trim().toLowerCase();
        var sizeNum = (sizeNorm.match(/^\d+/) || [])[0];
        var match = vis.sizeIn.some(function (s) {
          var n = String(s || '').replace(/\s+/g, ' ').replace(/[""]/g, '').trim().toLowerCase();
          var num = (n.match(/^\d+/) || [])[0];
          return sizeNorm === n || (sizeNum && num && sizeNum === num) || sizeNorm.indexOf(n) >= 0 || n.indexOf(sizeNorm) >= 0;
        });
        if (!match) return false;
      }
      if (addon.excludedWhenSetupKey && String(state.selectedGroupId || '') === String(addon.excludedWhenSetupKey)) {
        return false;
      }
      return true;
    }

    function syncAddonsPagination(visibleAddonCount) {
      var hasPagination = visibleAddonCount > 1;
      if (addonsButtonsContainer) {
        if (hasPagination) {
          addonsButtonsContainer.removeAttribute('hidden');
        } else {
          addonsButtonsContainer.setAttribute('hidden', '');
        }
      }
      if (addonsCounterTotal) addonsCounterTotal.textContent = String(Math.max(visibleAddonCount, 1));
      if (addonsCounterCurrent) addonsCounterCurrent.textContent = '1';
      if (addonsDotsContainer) {
        addonsDotsContainer.innerHTML = '';
        if (hasPagination) {
          for (var i = 1; i <= visibleAddonCount; i += 1) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'cart-drawer-recommendations__dot' + (i === 1 ? ' cart-drawer-recommendations__dot--active' : '');
            dot.setAttribute('data-slider-dot-index', String(i));
            dot.setAttribute('aria-label', 'Go to slide ' + i + ' of ' + visibleAddonCount);
            dot.setAttribute('aria-current', i === 1 ? 'true' : 'false');
            addonsDotsContainer.appendChild(dot);
          }
        }
      }
      if (addonsSliderComponent) {
        // Re-bind dots and recompute pages now that the slide/dot DOM has changed.
        addonsSliderComponent.sliderDotButtons = Array.prototype.slice.call(
          addonsSliderComponent.querySelectorAll('[data-slider-dot-index]')
        );
        if (typeof addonsSliderComponent.bindSliderDots === 'function') {
          addonsSliderComponent.bindSliderDots();
        }
        if (typeof addonsSliderComponent.resetPages === 'function') {
          addonsSliderComponent.resetPages();
        }
      }
    }

    function renderAddons() {
      if (!addonsContainer) return 0;
      var addons = loadAddonData();
      var visibleAddonCount = 0;
      var preservedScrollLeft = addonsContainer.scrollLeft || 0;

      addonsContainer.innerHTML = '';

      var selectedGroup = getSelectedGroup();
      var groupKey = selectedGroup ? String(selectedGroup.key || selectedGroup.id || '') : '';

      addons.forEach(function (addon) {
        if (addon.excludedWhenSetupKey && groupKey === String(addon.excludedWhenSetupKey)) {
          return;
        }
        if (!isAddonVisible(addon)) return;
        visibleAddonCount += 1;

        var slide = document.createElement('li');
        slide.className = 'krs-bundle-builder__addons-slide slider__slide';
        slide.id = 'Slide-KrsBundleAddons-' + uid + '-' + visibleAddonCount;

        var card = document.createElement('div');
        card.className = 'krs-bundle-builder__addon-card cart-drawer-recommendations__item';
        card.setAttribute('data-addon-key', addon.key);

        var sel = state.selectedAddons[addon.key];
        var hasVariantPicker = !!(addon.hasVariantPicker && (addon.variants || []).length > 1);
        if (hasVariantPicker && !sel && !(state.pendingAddonSelections && state.pendingAddonSelections[addon.key])) {
          var defaultVariant = (addon.variants || [])[0];
          if (defaultVariant && defaultVariant.variantId) {
            state.pendingAddonSelections = state.pendingAddonSelections || {};
            state.pendingAddonSelections[addon.key] = {
              variantId: defaultVariant.variantId,
              title: addon.title,
              optionValue: defaultVariant.optionValue,
              priceCents: defaultVariant.priceCents,
              compareAtCents: defaultVariant.compareAtCents
            };
          }
        }
        var pendingSel = (state.pendingAddonSelections && state.pendingAddonSelections[addon.key]) || null;
        var isAdded = !!sel && !!sel.variantId;
        var effectiveSelection = sel || pendingSel;
        var displayVariantId = effectiveSelection && effectiveSelection.variantId ? effectiveSelection.variantId : addon.variantId;
        var displayPriceCents = effectiveSelection && effectiveSelection.priceCents != null ? effectiveSelection.priceCents : (addon.priceCents || 0);
        var displayCompareAtCents = effectiveSelection && effectiveSelection.compareAtCents != null ? effectiveSelection.compareAtCents : (addon.compareAtCents || 0);
        if (displayCompareAtCents < displayPriceCents) displayCompareAtCents = 0;
        var displaySavingsCents = displayCompareAtCents > displayPriceCents ? (displayCompareAtCents - displayPriceCents) : 0;
        var priceParts = formatMoneyParts(displayPriceCents);
        var compareParts = formatMoneyParts(displayCompareAtCents);

        var imgSrc = addon.imageUrl;
        if (imgSrc) {
          var sep = imgSrc.indexOf('?') >= 0 ? '&' : '?';
          imgSrc = imgSrc + sep + 'width=180';
        }
        var imgHtml = imgSrc
          ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(addon.title || '') + '" loading="lazy" width="90" height="90">'
          : '<span class="krs-bundle-builder__thumb-fallback">' + escapeHtml((addon.title || 'AD').slice(0, 2).toUpperCase()) + '</span>';

        var variantPickerHtml = '';
        if (hasVariantPicker) {
          variantPickerHtml =
            '<div class="krs-bundle-builder__addon-variant-picker" data-addon-key="' + escapeHtml(addon.key) + '">' +
              '<div class="krs-bundle-builder__addon-variant-btns"></div>' +
            '</div>';
        }

        var contentHtml =
          '<div class="cart-drawer-recommendations__image krs-bundle-builder__addon-thumb">' + imgHtml + '</div>' +
          '<div class="cart-drawer-recommendations__content krs-bundle-builder__addon-content' + (hasVariantPicker ? ' krs-bundle-builder__addon-content--has-variants' : '') + '">' +
            '<div class="krs-bundle-builder__addon-title-row">' +
              '<div class="cart-drawer-recommendations__name">' + escapeHtml(addon.title || 'Add-on') + '</div>' +
              (addon.subtitle ? '<div class="krs-bundle-builder__addon-subtitle">' + escapeHtml(addon.subtitle) + '</div>' : '') +
            '</div>' +
            variantPickerHtml +
            '<div class="cart-drawer-recommendations__meta">' +
              '<div class="cart-drawer-recommendations__price krs-bundle-builder__addon-price-row">' +
                '<span class="price-item price-item--regular" data-role="addon-current-price">' +
                  '<span class="price__dollars">' + escapeHtml(priceParts.dollars) + '</span><span class="price__cents">' + escapeHtml(priceParts.cents) + '</span>' +
                '</span>' +
                '<s class="price-item price-item--regular cart-drawer-recommendations__price--compare"' + (displayCompareAtCents > displayPriceCents ? '' : ' style="display:none"') + '>' +
                  '<span class="price__dollars">' + escapeHtml(compareParts.dollars) + '</span><span class="price__cents">' + escapeHtml(compareParts.cents) + '</span>' +
                '</s>' +
                '<span class="krs-bundle-builder__savings-badge"' + (displaySavingsCents > 0 ? '' : ' style="display:none"') + '>' + (displaySavingsCents > 0 ? escapeHtml(tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(displaySavingsCents) })) : '') + '</span>' +
              '</div>' +
            '</div>' +
            '<div class="cart-drawer-recommendations__actions">' +
              '<button type="button" class="button ' + (isAdded ? 'button--primary' : 'button--secondary') + ' cart-drawer-recommendations__button krs-bundle-builder__addon-toggle" data-addon-key="' + escapeHtml(addon.key) + '">' +
                (isAdded ? 'Added' : 'Add') +
              '</button>' +
            '</div>' +
          '</div>';

        card.innerHTML = contentHtml;

        if (hasVariantPicker) {
          var btnsWrap = card.querySelector('.krs-bundle-builder__addon-variant-btns');
          if (btnsWrap) {
          (addon.variants || []).forEach(function (v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'krs-bundle-builder__addon-variant-btn';
            btn.textContent = v.optionValue || v.variantId;
            btn.setAttribute('data-variant-id', v.variantId);
            btn.setAttribute('data-price-cents', v.priceCents);
            if ((sel && sel.variantId === v.variantId) || (pendingSel && pendingSel.variantId === v.variantId)) {
              btn.classList.add('is-active');
            }
            btn.addEventListener('click', function () {
              var nextSelection = {
                variantId: v.variantId,
                title: addon.title,
                optionValue: v.optionValue,
                priceCents: v.priceCents,
                compareAtCents: v.compareAtCents
              };
              state.pendingAddonSelections = state.pendingAddonSelections || {};
              state.pendingAddonSelections[addon.key] = nextSelection;
              if (state.selectedAddons[addon.key] && state.selectedAddons[addon.key].variantId) {
                state.selectedAddons[addon.key] = nextSelection;
              }
              renderAddons();
              formatSummary();
            });
            btnsWrap.appendChild(btn);
          });
          }
        }

        var toggleBtn = card.querySelector('.krs-bundle-builder__addon-toggle');
        if (toggleBtn) {
          toggleBtn.addEventListener('click', function () {
            if (isAdded) {
              delete state.selectedAddons[addon.key];
            } else {
              if (hasVariantPicker) {
                var first = addon.variants[0];
                var chosen = (state.pendingAddonSelections && state.pendingAddonSelections[addon.key]) || {
                  variantId: first.variantId,
                  title: addon.title,
                  optionValue: first.optionValue,
                  priceCents: first.priceCents,
                  compareAtCents: first.compareAtCents
                };
                state.selectedAddons[addon.key] = {
                  variantId: chosen.variantId,
                  title: addon.title,
                  optionValue: chosen.optionValue,
                  priceCents: chosen.priceCents,
                  compareAtCents: chosen.compareAtCents
                };
              } else {
                state.selectedAddons[addon.key] = {
                  variantId: addon.variantId,
                  title: addon.title,
                  priceCents: addon.priceCents || 0,
                  compareAtCents: addon.compareAtCents || 0
                };
              }
            }
            renderAddons();
            formatSummary();
          });
        }

        slide.appendChild(card);
        addonsContainer.appendChild(slide);
      });

      if (preservedScrollLeft > 0 && addonsContainer.scrollWidth > addonsContainer.clientWidth) {
        addonsContainer.scrollLeft = Math.min(preservedScrollLeft, addonsContainer.scrollWidth - addonsContainer.clientWidth);
      }

      syncAddonsPagination(visibleAddonCount);

      return visibleAddonCount;
    }

    function updateGroupPriceDisplays() {
      Array.prototype.forEach.call(groupsContainer.querySelectorAll('.krs-bundle-builder__group[data-group-id]'), function (node) {
        var bundlePriceCents = Number(node.getAttribute('data-bundle-price-cents') || 0);
        var bundleCompareCents = Number(node.getAttribute('data-bundle-compare-cents') || 0);
        var badgeSavingsCents = Number(node.getAttribute('data-badge-savings-cents') || 0);

        var basePriceForDisplay = Number(
          state.selectedVariantPriceCents || (data && data.baseVariant && data.baseVariant.priceCents) || 0
        );
        var currentTotal = basePriceForDisplay + bundlePriceCents;
        var compareTotal = basePriceForDisplay + bundleCompareCents;
        var computedSavings = Math.max(0, compareTotal - currentTotal);
        var savings = Math.max(computedSavings, badgeSavingsCents);
        if (compareTotal <= currentTotal && badgeSavingsCents > 0) {
          compareTotal = currentTotal + badgeSavingsCents;
        }

        var currentDollars = node.querySelector('[data-role="group-current-dollars"]');
        var currentCents = node.querySelector('[data-role="group-current-cents"]');
        var compareNode = node.querySelector('[data-role="group-compare-price"]');
        var compareDollars = node.querySelector('[data-role="group-compare-dollars"]');
        var compareCents = node.querySelector('[data-role="group-compare-cents"]');
        var savingsBadgeNode = node.querySelector('[data-role="group-savings-badge"]');
        var calloutBadgeNode = node.querySelector('[data-role="group-callout-badge"]');

        var currentParts = formatMoneyParts(currentTotal);
        if (currentDollars) currentDollars.textContent = currentParts.dollars;
        if (currentCents) currentCents.textContent = currentParts.cents;

        if (compareNode && compareDollars && compareCents) {
          if (compareTotal > currentTotal) {
            var compareParts = formatMoneyParts(compareTotal);
            compareDollars.textContent = compareParts.dollars;
            compareCents.textContent = compareParts.cents;
            compareNode.style.display = '';
          } else {
            compareNode.style.display = 'none';
          }
        }
        if (savingsBadgeNode) {
          if (savings > 0) {
            savingsBadgeNode.textContent = tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savings) });
            savingsBadgeNode.style.display = 'inline-flex';
          } else {
            savingsBadgeNode.textContent = '';
            savingsBadgeNode.style.display = 'none';
          }
        }
        if (calloutBadgeNode) {
          var badgeCallout = String(node.getAttribute('data-badge-callout') || '').trim();
          if (badgeCallout) {
            calloutBadgeNode.textContent = badgeCallout;
            calloutBadgeNode.style.display = 'inline-block';
          } else {
            calloutBadgeNode.textContent = '';
            calloutBadgeNode.style.display = 'none';
          }
        }
      });
    }

    function resolveOptionDisclaimer(label) {
      var disclaimers = data && data.optionDisclaimers;
      if (!disclaimers || typeof disclaimers !== 'object' || Array.isArray(disclaimers)) return '';
      var raw = String(label == null ? '' : label);
      if (Object.prototype.hasOwnProperty.call(disclaimers, raw)) {
        return String(disclaimers[raw] || '').trim();
      }
      var stripped = raw.trim();
      if (stripped !== raw && Object.prototype.hasOwnProperty.call(disclaimers, stripped)) {
        return String(disclaimers[stripped] || '').trim();
      }
      var normalizedTarget = normalizeTwoStepLabel(raw);
      if (!normalizedTarget) return '';
      var keys = Object.keys(disclaimers);
      for (var i = 0; i < keys.length; i += 1) {
        if (normalizeTwoStepLabel(keys[i]) === normalizedTarget) {
          return String(disclaimers[keys[i]] || '').trim();
        }
      }
      return '';
    }

    function updateSizeDisclaimer(label) {
      if (!sizeDisclaimerContainer || !sizeDisclaimerTextEl) return;
      var text = resolveOptionDisclaimer(label);
      if (text) {
        sizeDisclaimerTextEl.textContent = text;
        sizeDisclaimerContainer.removeAttribute('hidden');
        // Force layout flush so the transition runs reliably even when re-selecting.
        void sizeDisclaimerContainer.offsetWidth;
        sizeDisclaimerContainer.classList.add('is-visible');
      } else {
        sizeDisclaimerContainer.classList.remove('is-visible');
        sizeDisclaimerContainer.setAttribute('hidden', '');
        sizeDisclaimerTextEl.textContent = '';
      }
    }

    function applySizeSelection(opt, label, card, options) {
      options = options || {};
      state.selectedSize = label;
      state.selectedVariantId = normalizeVariantId(opt && opt.variantId);
      state.selectedVariantPriceCents = Number((opt && opt.priceCents) || 0);
      syncBundleSelectionWithNativeFlow(opt, label);
      updateSizeDisclaimer(label);

      Array.prototype.forEach.call(sizeContainer.querySelectorAll('.krs-bundle-builder__size-card'), function (c) {
        c.classList.remove('is-active');
        var cBtn = c.querySelector('.krs-bundle-builder__size-btn');
        if (cBtn) cBtn.setAttribute('aria-pressed', 'false');
      });
      if (card) {
        card.classList.add('is-active');
        var activeBtn = card.querySelector('.krs-bundle-builder__size-btn');
        if (activeBtn) activeBtn.setAttribute('aria-pressed', 'true');
      }
      ensureGroupsRendered();
      updateGroupPriceDisplays();
      updateBaseProductThumbs();
      updateStep2Visibility();
      updateStep3Visibility();
      formatSummary();

      if (!options.skipUrlWrite) writeStep1ToUrl(opt);
      if (!options.skipMobileScroll) requestAnimationFrame(function () { scrollToStep1IfMobile(); });
    }

    function applyStep1SelectionFromUrl(options) {
      options = options || {};
      if (!sizeOptionCards.length) return false;
      var urlState = readUrlState();
      var sizeOptionIndex = Number(data && data.sizeOptionIndex);
      if (isNaN(sizeOptionIndex)) sizeOptionIndex = 0;
      var targetOptionValueId = urlState.optionValues[sizeOptionIndex] ? String(urlState.optionValues[sizeOptionIndex]) : '';
      var targetVariantId = urlState.variantId ? String(urlState.variantId) : '';
      var match = null;

      if (targetOptionValueId) {
        for (var i = 0; i < sizeOptionCards.length; i += 1) {
          var candidateOptionValueId = sizeOptionCards[i].opt && sizeOptionCards[i].opt.optionValueId ? String(sizeOptionCards[i].opt.optionValueId) : '';
          if (candidateOptionValueId && candidateOptionValueId === targetOptionValueId) {
            match = sizeOptionCards[i];
            break;
          }
        }
      }

      if (!match && targetVariantId) {
        for (var j = 0; j < sizeOptionCards.length; j += 1) {
          var candidateVariantId = normalizeVariantId(sizeOptionCards[j].opt && sizeOptionCards[j].opt.variantId);
          if (candidateVariantId && String(candidateVariantId) === targetVariantId) {
            match = sizeOptionCards[j];
            break;
          }
        }
      }

      if (!match || !match.opt || !match.opt.available || !match.opt.variantId) return false;
      applySizeSelection(match.opt, match.label, match.card, {
        skipUrlWrite: options.skipUrlWrite !== false,
        skipMobileScroll: options.skipMobileScroll !== false
      });
      return true;
    }

    function findGroupById(groupId) {
      var targetId = String(groupId || '');
      if (!targetId) return null;
      for (var i = 0; i < groupsData.length; i += 1) {
        if (String(groupsData[i].id) === targetId) return groupsData[i];
      }
      return null;
    }

    function findGroupBySetupKey(setupKey) {
      var target = String(setupKey || '').trim();
      if (!target) return null;
      for (var i = 0; i < groupsData.length; i += 1) {
        if (String(groupsData[i].key || '') === target || String(groupsData[i].id || '') === target) return groupsData[i];
      }
      return null;
    }

    function applyStep2SelectionFromUrl(options) {
      options = options || {};
      var setupKey = options.setupKey;
      if (setupKey == null) {
        var urlState = readUrlState();
        setupKey = urlState.bundleSetup;
      }
      if (!setupKey) return false;
      if ((!setSelectedGroupFn || !groupsData.length) && !state.groupsRendered) {
        ensureGroupsRendered();
      }
      if (typeof setSelectedGroupFn !== 'function' || !groupsData.length) return false;
      var targetGroup = findGroupBySetupKey(setupKey);
      if (!targetGroup) return false;
      setSelectedGroupFn(targetGroup.id, { skipUrlWrite: options.skipUrlWrite !== false });
      return true;
    }

    function applyUrlStateToBundle(options) {
      options = options || {};
      state.suppressUrlSync = true;
      try {
        applyStep1SelectionFromUrl({
          skipUrlWrite: true,
          skipMobileScroll: true
        });
        applyStep2SelectionFromUrl({
          skipUrlWrite: true
        });
      } finally {
        state.suppressUrlSync = false;
      }
      if (!options.skipSummaryRefresh) {
        updateStep2Visibility();
        updateStep3Visibility();
        formatSummary();
      }
    }

    function ensureGroupsRendered() {
      if (state.groupsRendered) return;
      perf.mark('render-groups-start');
      renderGroups();
      perf.mark('render-groups-end');
      perf.measure('render-groups', 'render-groups-start', 'render-groups-end');
      state.groupsRendered = true;
    }

    function buildSizeOptionBadgeHtml(opt) {
      var isSoldOut = !!(opt && opt.variantId && !opt.available);
      if (isSoldOut) {
        return '<span class="krs-bundle-builder__size-sold-out">' + escapeHtml(tStr('soldOut', 'Sold Out')) + '</span>';
      }
      var savingsCents = Math.max(0, Number((opt && opt.compareAtCents) || 0) - Number((opt && opt.priceCents) || 0));
      if (savingsCents > 0) {
        return '<span class="krs-bundle-builder__size-saving">' + escapeHtml(tStr('save', 'Save {{ amount }}', { amount: formatMoneyWithoutTrailingZeros(savingsCents) })) + '</span>';
      }
      return '';
    }

    function updateSizeOptionBadge(card, opt) {
      if (!card || !opt) return;
      var priceBlock = card.querySelector('.krs-bundle-builder__size-price-block');
      if (!priceBlock) return;
      var existingSaving = priceBlock.querySelector('.krs-bundle-builder__size-saving');
      var existingSoldOut = priceBlock.querySelector('.krs-bundle-builder__size-sold-out');
      if (existingSaving) existingSaving.remove();
      if (existingSoldOut) existingSoldOut.remove();
      var badgeHtml = buildSizeOptionBadgeHtml(opt);
      if (badgeHtml) priceBlock.insertAdjacentHTML('beforeend', badgeHtml);
    }

    function renderSizes() {
      sizeOptionCards = [];
      var sizeOptions = data.sizeOptions || [];
      var hasOptionValueIds = sizeOptions.some(function (opt) { return !!(opt && opt.optionValueId); });
      if (!hasOptionValueIds && sizeOptions.length) {
        root.setAttribute('data-krs-bundle-debug', 'missing-option-value-ids');
      }
      if (!sizeOptions.length) {
        sizeContainer.style.display = 'none';
        state.selectedSize = '';
        state.selectedVariantId = data.baseVariant && data.baseVariant.variantId ? data.baseVariant.variantId : null;
        state.selectedVariantPriceCents = Number((data.baseVariant && data.baseVariant.priceCents) || 0);
        updateGroupPriceDisplays();
        updateStep2Visibility();
        updateStep3Visibility();
        formatSummary();
        return;
      }

      if (sizeOptions.length === 1) {
        sizeContainer.style.display = '';
        var only = sizeOptions[0];
        var onlyLabel = only && only.label && only.label !== 'Default Title' ? only.label : '';
        var onlyCard = sizeContainer.querySelector('.krs-bundle-builder__size-card');
        if (onlyCard && !onlyCard.__krsBound) {
          var onlyBtn = onlyCard.querySelector('.krs-bundle-builder__size-btn');
          if (onlyBtn) {
            onlyBtn.__krsBound = true;
            onlyBtn.addEventListener('click', function () {
              applySizeSelection(only, onlyLabel, onlyCard);
            });
          }
          onlyCard.__krsBound = true;
        }
        applySizeSelection(only, onlyLabel, onlyCard, { skipMobileScroll: true });
        return;
      }

      sizeContainer.style.display = '';
      var existingCards = sizeContainer.querySelectorAll('.krs-bundle-builder__size-card');
      var canBindExisting = existingCards && existingCards.length === sizeOptions.length;

      if (canBindExisting) {
        sizeOptions.forEach(function (opt, index) {
          var card = existingCards[index];
          if (!card) return;
          var btn = card.querySelector('.krs-bundle-builder__size-btn');
          if (!btn) return;
          var label = opt && typeof opt.label === 'object'
            ? (opt.label.value || opt.label.name || opt.label.label || ('Option ' + (index + 1)))
            : (opt.label || ('Option ' + (index + 1)));
          if (opt && opt.optionValueId) btn.setAttribute('data-option-value-id', String(opt.optionValueId));
          if (opt && opt.variantId) btn.setAttribute('data-variant-id', String(normalizeVariantId(opt.variantId)));
          btn.disabled = !opt.available || !opt.variantId;
          updateSizeOptionBadge(card, opt);
          if (!btn.__krsBound) {
            btn.__krsBound = true;
            btn.addEventListener('click', function () {
              applySizeSelection(opt, label, card);
            });
          }
          sizeOptionCards.push({ opt: opt, label: label, card: card, button: btn });
        });
      } else {
        // Fallback for non-standard markup: build options in JS.
        sizeContainer.innerHTML = '';
        sizeOptions.forEach(function (opt, index) {
          var label = opt && typeof opt.label === 'object'
            ? (opt.label.value || opt.label.name || opt.label.label || ('Option ' + (index + 1)))
            : (opt.label || ('Option ' + (index + 1)));
          var card = document.createElement('div');
          card.className = 'krs-bundle-builder__size-card';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'krs-bundle-builder__size-btn';
          var badgeHtml = buildSizeOptionBadgeHtml(opt);
          var optionPriceCents = Number((opt && opt.priceCents) || 0);
          var priceHtml = '';
          if (optionPriceCents > 0) {
            var priceParts = formatMoneyParts(optionPriceCents);
            priceHtml =
              '<span class="krs-bundle-builder__size-price price-item price-item--regular">' +
                '<span class="price__dollars">' + escapeHtml(priceParts.dollars) + '</span>' +
                '<span class="price__cents">' + escapeHtml(priceParts.cents) + '</span>' +
              '</span>';
          }
          var priceBlockHtml = (priceHtml || badgeHtml)
            ? ('<span class="krs-bundle-builder__size-price-block">' + priceHtml + badgeHtml + '</span>')
            : '';
          btn.innerHTML =
            '<span class="krs-bundle-builder__size-content">' +
              '<span class="krs-bundle-builder__size-title-row">' +
                '<span class="krs-bundle-builder__size-label">' + escapeHtml(label) + '</span>' +
                priceBlockHtml +
              '</span>' +
            '</span>';
          if (opt && opt.optionValueId) btn.setAttribute('data-option-value-id', String(opt.optionValueId));
          if (opt && opt.variantId) btn.setAttribute('data-variant-id', String(normalizeVariantId(opt.variantId)));
          btn.disabled = !opt.available || !opt.variantId;
          btn.addEventListener('click', function () {
            applySizeSelection(opt, label, card);
          });
          card.appendChild(btn);
          sizeContainer.appendChild(card);
          sizeOptionCards.push({ opt: opt, label: label, card: card, button: btn });
        });
      }

      function applyInitialMarkupSelection() {
        var activeFromMarkup = null;
        for (var i = 0; i < sizeOptionCards.length; i += 1) {
          var entry = sizeOptionCards[i];
          if (!entry || !entry.card || !entry.opt || !entry.opt.available || !entry.opt.variantId) continue;
          var btn = entry.button;
          var markupActive = entry.card.classList.contains('is-active') || (btn && btn.getAttribute('aria-pressed') === 'true');
          if (markupActive) {
            activeFromMarkup = entry;
            break;
          }
        }
        if (!activeFromMarkup) return false;
        state.selectedSize = activeFromMarkup.label;
        state.selectedVariantId = normalizeVariantId(activeFromMarkup.opt.variantId);
        state.selectedVariantPriceCents = Number(activeFromMarkup.opt.priceCents || 0);
        ensureGroupsRendered();
        updateGroupPriceDisplays();
        updateBaseProductThumbs();
        return true;
      }

      var appliedFromUrl = applyStep1SelectionFromUrl({ skipUrlWrite: true, skipMobileScroll: true });
      if (!appliedFromUrl) {
        var appliedFromMarkup = applyInitialMarkupSelection();
        if (!appliedFromMarkup) {
          var firstAvailable = null;
          for (var availableIdx = 0; availableIdx < sizeOptionCards.length; availableIdx += 1) {
            var availableEntry = sizeOptionCards[availableIdx];
            if (!availableEntry || !availableEntry.opt || !availableEntry.opt.available || !availableEntry.opt.variantId) continue;
            firstAvailable = availableEntry;
            break;
          }
          if (firstAvailable) {
            applySizeSelection(firstAvailable.opt, firstAvailable.label, firstAvailable.card, {
              skipUrlWrite: true,
              skipMobileScroll: true
            });
          }
        }
      }
    }

    function renderGroups() {
      function resolveGroupImageUrl(group) {
        var configured = group && group.imageUrl ? String(group.imageUrl) : '';
        if (configured) return configured;
        var key = String((group && group.key) || (group && group.id) || '').trim();
        if (key && COMBINED_GROUP_IMAGE_BY_KEY[key]) {
          return COMBINED_GROUP_IMAGE_BY_KEY[key];
        }
        return getBaseProductImageForSelectedSize() || '';
      }

      var configuredGroups = (Array.isArray(data.groups) ? data.groups : []).filter(function (group) {
        var key = String((group && group.key) || '').toLowerCase();
        var id = String((group && group.id) || '').toLowerCase();
        return key !== 'base-only' && id !== 'base-only';
      });

      groupsData = ensureGroupIds(configuredGroups);
      var explicitDefault = null;
      for (var i = 0; i < groupsData.length; i += 1) {
        if (groupsData[i].defaultSelected) {
          explicitDefault = groupsData[i];
          break;
        }
      }
      state.selectedGroupId = explicitDefault ? explicitDefault.id : (groupsData[0] ? groupsData[0].id : null);
      var existingGroupCards = groupsContainer.querySelectorAll('.krs-bundle-builder__group[data-group-id]');
      var canBindExisting = !!existingGroupCards.length && existingGroupCards.length === groupsData.length;
      if (canBindExisting) {
        // Rebuild when legacy multi-thumb markup exists so new single-thumb layout can apply.
        if (
          groupsContainer.querySelector('.krs-bundle-builder__thumbs') ||
          groupsContainer.querySelector('.krs-bundle-builder__thumb-plus') ||
          !groupsContainer.querySelector('.krs-bundle-builder__group-thumb')
        ) {
          canBindExisting = false;
        }
      }
      if (canBindExisting) {
        for (var cardIdx = 0; cardIdx < groupsData.length; cardIdx += 1) {
          var groupNode = groupsContainer.querySelector('.krs-bundle-builder__group[data-group-id="' + escapeSelectorValue(groupsData[cardIdx].id) + '"]');
          if (!groupNode || !groupNode.querySelector('input[type="radio"][data-group-id]')) {
            canBindExisting = false;
            break;
          }
        }
      }

      if (!canBindExisting) {
        groupsContainer.innerHTML = '';

        groupsData.forEach(function (group) {
          var bundlePriceCents = (group.products || []).reduce(function (sum, p) {
            return sum + Number(p.priceCents || 0);
          }, 0);
          var bundleCompareCents = (group.products || []).reduce(function (sum, p) {
            return sum + Number(p.compareAtCents || 0);
          }, 0);
          var badgeSavingsCents = parseBadgeSavingsCents(group.badge);

          var wrap = document.createElement('div');
          wrap.className = 'krs-bundle-builder__group';
          wrap.setAttribute('data-group-id', group.id);
          wrap.setAttribute('data-bundle-price-cents', String(bundlePriceCents));
          wrap.setAttribute('data-bundle-compare-cents', String(bundleCompareCents));
          wrap.setAttribute('data-badge-savings-cents', String(badgeSavingsCents));
          wrap.setAttribute('data-badge-callout', String(group.badgeCallout || ''));

          var groupImageUrl = resolveGroupImageUrl(group);
          var groupImageSource = group.imageUrl || COMBINED_GROUP_IMAGE_BY_KEY[String(group.key || group.id || '').trim()] ? 'custom' : 'base';
          var groupImageLabel = String(group.title || 'Setup image');
          var groupImageSrc = groupImageUrl ? (groupImageUrl + (groupImageUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=140') : '';
          var groupImageHtml = groupImageSrc
            ? '<span class="krs-bundle-builder__group-thumb" data-group-image-source="' + groupImageSource + '">' +
                '<img src="' + escapeHtml(groupImageSrc) + '" alt="' + escapeHtml(groupImageLabel) + '" loading="lazy">' +
              '</span>'
            : '';

          var groupCheckSvg = '<svg class="krs-bundle-builder__group-check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 6l3 3 5-6"/></svg>';
          wrap.innerHTML =
            '<input class="krs-bundle-builder__group-radio visually-hidden" type="radio" name="krs-bundle-setup-' + escapeHtml(uid) + '" data-group-id="' + group.id + '"' + (group.id === state.selectedGroupId ? ' checked' : '') + '>' +
            '<div class="krs-bundle-builder__group-main">' +
              '<div class="krs-bundle-builder__group-top-row">' +
                '<span class="krs-bundle-builder__group-check" aria-hidden="true">' + groupCheckSvg + '</span>' +
                groupImageHtml +
                '<div class="krs-bundle-builder__group-top-left">' +
                  '<div class="krs-bundle-builder__group-title-row">' +
                    '<h4 class="krs-bundle-builder__group-title">' + escapeHtml(group.title || 'Setup group') + '</h4>' +
                    '<span class="krs-bundle-builder__badge krs-bundle-builder__badge--callout" data-role="group-callout-badge"></span>' +
                  '</div>' +
                  '<div class="cart-drawer-recommendations__meta">' +
                    '<div class="cart-drawer-recommendations__price cart-drawer-recommendations__price--top">' +
                      '<span class="price-item price-item--regular" data-role="group-current-price">' +
                        '<span class="price__dollars" data-role="group-current-dollars"></span><span class="price__cents" data-role="group-current-cents"></span>' +
                      '</span>' +
                      '<s class="price-item price-item--regular cart-drawer-recommendations__price--compare" data-role="group-compare-price">' +
                        '<span class="price__dollars" data-role="group-compare-dollars"></span><span class="price__cents" data-role="group-compare-cents"></span>' +
                      '</s>' +
                      '<span class="krs-bundle-builder__savings-badge" data-role="group-savings-badge"></span>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              (group.description ? '<p class="krs-bundle-builder__group-sub">' + escapeHtml(group.description) + '</p>' : '') +
              (group.note ? '<p class="krs-bundle-builder__group-note">' + escapeHtml(group.note) + '</p>' : '') +
            '</div>' +
            '';

          groupsContainer.appendChild(wrap);
        });
      } else {
        groupsData.forEach(function (group) {
          var existingCard = groupsContainer.querySelector('.krs-bundle-builder__group[data-group-id="' + escapeSelectorValue(group.id) + '"]');
          if (!existingCard) return;
          var bundlePriceCents = (group.products || []).reduce(function (sum, p) {
            return sum + Number(p.priceCents || 0);
          }, 0);
          var bundleCompareCents = (group.products || []).reduce(function (sum, p) {
            return sum + Number(p.compareAtCents || 0);
          }, 0);
          var badgeSavingsCents = parseBadgeSavingsCents(group.badge);
          existingCard.setAttribute('data-bundle-price-cents', String(bundlePriceCents));
          existingCard.setAttribute('data-bundle-compare-cents', String(bundleCompareCents));
          existingCard.setAttribute('data-badge-savings-cents', String(badgeSavingsCents));
          existingCard.setAttribute('data-badge-callout', String(group.badgeCallout || ''));
        });
      }

      function setSelectedGroup(groupId, options) {
        options = options || {};
        state.selectedGroupId = String(groupId || '');
        Array.prototype.forEach.call(groupsContainer.querySelectorAll('input[type="radio"][data-group-id]'), function (radio) {
          radio.checked = String(radio.getAttribute('data-group-id')) === state.selectedGroupId;
        });
        syncGroupSelectionVisual();
        updateStep3Visibility();
        formatSummary();
        if (!options.skipUrlWrite) {
          writeStep2ToUrl(findGroupById(state.selectedGroupId));
        }
      }

      function syncGroupSelectionVisual() {
        Array.prototype.forEach.call(groupsContainer.querySelectorAll('.krs-bundle-builder__group'), function (groupNode) {
          var radio = groupNode.querySelector('input[type="radio"][data-group-id]');
          if (!radio) return;
          groupNode.classList.toggle('is-selected', radio.checked);
        });
      }

      setSelectedGroupFn = setSelectedGroup;
      syncGroupSelectionVisual();

      groupsContainer.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || !target.matches('input[type="radio"][data-group-id]')) return;
        var gid = target.getAttribute('data-group-id');
        setSelectedGroup(gid);
      });

      groupsContainer.addEventListener('click', function (event) {
        var card = event.target && event.target.closest ? event.target.closest('.krs-bundle-builder__group[data-group-id]') : null;
        if (!card) return;
        var gid = card.getAttribute('data-group-id');
        if (!gid || String(gid) === String(state.selectedGroupId)) return;
        setSelectedGroup(gid);
      });

      if (!applyStep2SelectionFromUrl({ skipUrlWrite: true })) {
        setSelectedGroup(state.selectedGroupId, { skipUrlWrite: true });
      }
      updateGroupPriceDisplays();
      updateBaseProductThumbs();
      updateStep3Visibility();
    }

    function buildLineItems() {
      var items = [];
      if (!state.selectedVariantId) return items;
      var mainVariantId = normalizeVariantId(state.selectedVariantId);
      if (!mainVariantId) return items;

      if (isTwoStepMode) {
        var twoStepBundleMeta = data.bundleMeta || {};
        var twoStepSizeLabel = String(state.selectedSize || '');
        var twoStepMode = String(state.selectedTwoStepMode || 'bike-only');
        var selectedUpliftAddon = twoStepMode === 'uplift' || twoStepMode === 'adventure' ? getUpliftAddonConfig() : null;
        var selectedAdventure = twoStepMode === 'adventure' ? getAdventureConfig() : null;
        var twoStepProperties = {
          _bundle_key: String(twoStepBundleMeta.bundleKey || 'bundle-builder'),
          _bundle_setup_key: String(twoStepMode || 'bike-only'),
          _bundle_version: String(twoStepBundleMeta.bundleVersion || 'v1'),
          _bundle_size: String(twoStepSizeLabel || '')
        };
        items.push({
          id: mainVariantId,
          quantity: 1,
          properties: Object.assign({}, twoStepProperties, {
            _bundle_parent: 'true',
            _bundle_role: 'base-product'
          })
        });
        if (selectedUpliftAddon && selectedUpliftAddon.available) {
          items.push({
            id: selectedUpliftAddon.variantId,
            quantity: 1,
            properties: Object.assign({}, twoStepProperties, {
              _bundle_parent: 'false',
              _bundle_addon_key: 'uplift-sku',
              _bundle_role: 'addon-uplift'
            })
          });
        }
        if (selectedAdventure && selectedAdventure.available && selectedAdventure.variantId) {
          items.push({
            id: selectedAdventure.variantId,
            quantity: 1,
            properties: Object.assign({}, twoStepProperties, {
              _bundle_parent: 'false',
              _bundle_addon_key: 'tow-rope',
              _bundle_role: 'addon-tow-rope'
            })
          });
        }
        Object.keys(state.selectedHelmets || {}).forEach(function (helmetKey) {
          var helmetSel = state.selectedHelmets[helmetKey];
          if (!helmetSel || !helmetSel.variantId) return;
          var helmetVariantId = normalizeVariantId(helmetSel.variantId);
          if (!helmetVariantId) return;
          items.push({
            id: helmetVariantId,
            quantity: 1,
            properties: Object.assign({}, twoStepProperties, {
              _bundle_parent: 'false',
              _bundle_addon_key: 'helmet',
              _bundle_role: 'addon-helmet'
            })
          });
        });
        return items;
      }

      function decodeEntities(value) {
        return String(value || '')
          .replace(/&quot;|&#34;/gi, '"')
          .replace(/&apos;|&#39;/gi, "'")
          .replace(/&amp;/gi, '&');
      }

      function normalizeSizeText(value) {
        return decodeEntities(value)
          .replace(/["\u201c\u201d]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      var selectedGroup = null;
      for (var i = 0; i < groupsData.length; i += 1) {
        if (String(groupsData[i].id) === String(state.selectedGroupId)) {
          selectedGroup = groupsData[i];
          break;
        }
      }

      var bundleMeta = data.bundleMeta || {};
      var sizePlain = normalizeSizeText(state.selectedSize || '');
      var bundleProperties = {
        _bundle_key: String(bundleMeta.bundleKey || 'bundle-builder'),
        _bundle_setup_key: String((selectedGroup && (selectedGroup.key || selectedGroup.id)) || 'base-only'),
        _bundle_version: String(bundleMeta.bundleVersion || 'v1'),
        _bundle_size: String(sizePlain || '')
      };

      items.push({
        id: mainVariantId,
        quantity: 1,
        properties: Object.assign({}, bundleProperties, { _bundle_parent: 'true', _bundle_role: 'base-product' })
      });

      if (selectedGroup && selectedGroup.products) {
        (selectedGroup.products || []).forEach(function (p) {
          var groupVariantId = normalizeVariantId(p.variantId);
          if (!groupVariantId) return;
          items.push({
            id: groupVariantId,
            quantity: 1,
            properties: Object.assign({}, bundleProperties, { _bundle_parent: 'false', _bundle_role: 'kit-item' })
          });
        });
      }

      Object.keys(state.selectedAddons || {}).forEach(function (addonKey) {
        var sel = state.selectedAddons[addonKey];
        if (!sel || !sel.variantId) return;
        var addonVariantId = normalizeVariantId(sel.variantId);
        if (!addonVariantId) return;
        var addonRole = 'Add-on: ' + (sel.title || addonKey);
        if (sel.optionValue) addonRole += ' (' + sel.optionValue + ')';
        items.push({
          id: addonVariantId,
          quantity: 1,
          properties: Object.assign({}, bundleProperties, {
            _bundle_parent: 'false',
            _bundle_addon_key: String(addonKey),
            _bundle_role: addonRole
          })
        });
      });

      return items;
    }

    function fetchAndRenderCartState(currentCartInstance) {
      if (!currentCartInstance || typeof currentCartInstance.getSectionsToRender !== 'function' || typeof currentCartInstance.renderContents !== 'function') {
        return Promise.reject(new Error('Cart UI renderer unavailable'));
      }

      var sectionsToRender = currentCartInstance.getSectionsToRender();
      if (!sectionsToRender || !sectionsToRender.length) {
        return Promise.reject(new Error('No cart sections configured'));
      }

      var sectionIds = sectionsToRender
        .map(function (s) { return s.section || s.id; })
        .filter(Boolean);
      var sectionsParam = sectionIds.join(',');

      return fetch('/cart.js?sections=' + encodeURIComponent(sectionsParam), { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cartState) {
          var sectionsPayload = {};
          sectionIds.forEach(function (id) {
            if (cartState.sections && cartState.sections[id]) {
              sectionsPayload[id] = cartState.sections[id];
            }
          });

          currentCartInstance.renderContents({
            id: cartState.token,
            item_count: cartState.item_count,
            total_price: cartState.total_price,
            sections: sectionsPayload
          });
        });
    }

    function notifyCartUpdated(productVariantId) {
      try {
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-builder', productVariantId: productVariantId });
        }
      } catch (e) {
        console.warn('Bundle builder cart publish failed:', e);
      }
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { source: 'bundle-builder', productVariantId: productVariantId }
        }));
      } catch (e2) {
        console.warn('Bundle builder cart:updated dispatch failed:', e2);
      }
    }

    addBtn.addEventListener('click', function () {
      if (!state.selectedVariantId) return;
      var items = buildLineItems();
      if (!items.length) return;

      setAddButtonDisabled(true);
      addBtn.textContent = tStr('adding', 'Adding...');
      syncStickySummary();

      var cartDrawer = document.querySelector('cart-drawer:not([data-cart-ab-inactive])');
      var currentCart = cartDrawer;
      var sections = [];
      if (currentCart && typeof currentCart.getSectionsToRender === 'function') {
        sections = currentCart.getSectionsToRender()
          .map(function (section) { return section.section || section.id; })
          .filter(Boolean);
      }

      var payload = { items: items };
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url = window.location.pathname;
      }

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.classList.add('is-loading');
        cartDrawer.classList.remove('is-empty');
        var drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
        var drawerItems = cartDrawer.querySelector('cart-drawer-items');
        if (drawerItems) drawerItems.classList.remove('is-empty');
        cartDrawer.open();
      }

      function requestAdd(addPayload) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify(addPayload)
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) {
              if (!res.ok || json.status) {
                var message = json.description || json.message || json.errors || 'Cart add failed';
                throw new Error(typeof message === 'string' ? message : 'Cart add failed');
              }
              return json;
            });
          });
      }

      requestAdd(payload)
        .then(function (response) {
          var productVariantId = String(normalizeVariantId(state.selectedVariantId) || '');
          function resetAddButton() {
            setAddButtonDisabled(false);
            addBtn.textContent = tStr('addToCart', 'Add to Cart');
            syncStickySummary();
          }

          if (currentCart && response && response.sections && typeof currentCart.renderContents === 'function') {
            try {
              if (cartDrawer) cartDrawer.classList.remove('is-loading');
              currentCart.renderContents(response);
              notifyCartUpdated(productVariantId);
              resetAddButton();
              return;
            } catch (renderError) {
              console.warn('Bundle builder cart render fallback:', renderError);
            }
          }

          if (currentCart && typeof currentCart.renderContents === 'function') {
            return fetchAndRenderCartState(currentCart).catch(function (error) {
              console.warn('Bundle builder cart state refresh fallback:', error);
              if (cartDrawer) cartDrawer.classList.remove('is-loading');
            }).then(function () {
              if (cartDrawer) cartDrawer.classList.remove('is-loading');
              notifyCartUpdated(productVariantId);
              resetAddButton();
            });
          }

          if (cartDrawer) cartDrawer.classList.remove('is-loading');
          notifyCartUpdated(productVariantId);
          resetAddButton();
          if (!cartDrawer) window.location.href = '/cart';
        })
        .catch(function (error) {
          if (cartDrawer) {
            cartDrawer.classList.remove('is-loading');
            if (typeof cartDrawer.close === 'function') cartDrawer.close();
          }
          setAddButtonDisabled(false);
          addBtn.textContent = tStr('addToCart', 'Add to Cart');
          syncStickySummary();
          var message = (error && error.message) ? error.message : 'Could not add the selected build. Please try again.';
          alert(message);
        });
    });

    perf.mark('render-sizes-start');
    if (isTwoStepMode) {
      renderTwoStepFlow();
    } else {
      renderSizes();
    }
    perf.mark('render-sizes-end');
    perf.measure('render-sizes', 'render-sizes-start', 'render-sizes-end');

    if (!isTwoStepMode) {
      applyUrlStateToBundle();
    }
    createStickySummaryBar();
    setupStickySummaryObserver();

    updateStep2Visibility();
    updateStep3Visibility();
    formatSummary();
    setupUpliftLearnMoreModal();
    if (twoStepHelmetData && twoStepHelmetData.configured) {
      bindHelmetCards();
      updateHelmetAvailability();
      syncHelmetVisualSelection();
      setupHelmetLearnMoreModals();
    }

    if (!isTwoStepMode && !root.__krsBundlePopstateBound) {
      root.__krsBundlePopstateBound = true;
      root.__krsBundlePopstateHandler = function () {
        applyUrlStateToBundle();
      };
      window.addEventListener('popstate', root.__krsBundlePopstateHandler);
    }

    perf.mark('interactive-ready');
    perf.measure('init-total', 'init-start', 'interactive-ready');
    perf.flush();
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('.krs-bundle-builder[id^="KrsBundle-"]') : [];
    Array.prototype.forEach.call(nodes, initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange && !window.__krsBundleVariantReinitBound) {
    window.__krsBundleVariantReinitBound = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data ? event.data : {};
      var sectionId = data && data.sectionId ? String(data.sectionId) : '';
      if (!sectionId) return;
      var sectionRoot = document.getElementById('MainProduct-' + sectionId);
      if (sectionRoot && sectionRoot.querySelector('.krs-bundle-builder') && window.__krsPendingBundleAddon) {
        try {
          var addonUrl = new URL(window.location.href);
          if (addonUrl.searchParams.get('addon') !== window.__krsPendingBundleAddon) {
            addonUrl.searchParams.set('addon', window.__krsPendingBundleAddon);
            window.history.replaceState({}, '', addonUrl.pathname + addonUrl.search + addonUrl.hash);
          }
        } catch (e) {}
      }
      if (sectionRoot) initAll(sectionRoot);
    });
  }
})();
// krs-bundle-builder | staging touch
